import { Settings, Visibility, VisibilityOff } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LoopIcon from "@mui/icons-material/Loop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ubuntu_white from "../../../assets/ubuntu_white.svg";
import windows_light from "../../../assets/baseVersion/Windows_light.svg";
import windows_dark from "../../../assets/baseVersion/Windows_dark.svg";
import ubuntu_dark from "../../../assets/ubuntu_dark.svg";
import debian from "../../../assets/debian.svg";
import debian_dark from "../../../assets/debian_dark.svg";
import redhat_light from "../../../assets/redhat_light.svg"
import redhat_dark from "../../../assets/redhat_dark.svg"
import huawei_light from "../../../assets/huawei-ar21 1.svg";
import mikrotik from "../../../assets/mikrotik.svg";
import mikrotik_dark from "../../../assets/mikrotik_dark.svg";
import huawei_dark from "../../../assets/huawei-dark.svg";
import edgecore_logo from "../../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../../assets/apple.svg";
import apple_dark from "../../../assets/apple_dark.svg";
import dell_logo from "../../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../assets/syrotech_dark.svg";
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Popover,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { ColDef, GridOptions, ICellRendererParams } from "ag-grid-community";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import * as Yup from "yup";
import arista_assets from "../../../assets/arista_v4_light.svg";
import arista_dark from "../../../assets/arista_v4_dark.svg";
import bule_calender from "../../../assets/bule-calender.svg";
import cisco_assets from "../../../assets/cisco_v4_light.svg";
import cisco_dark from "../../../assets/cisco_v4_dark.svg";
import Aws_img from "../../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../../assets/baseVersion/AWS_DARK.svg";
import cveBugError from "../../../assets/cve-bug-error.svg";
import cveBug from "../../../assets/cve-bug.svg";
import downloadIcon from "../../../assets/downloadIcon.svg";
import green_calender from "../../../assets/green-calender.svg";
import green_shield from "../../../assets/green-shield.svg";
// import juniper_dark from "../../../assets/juniper-white.svg";
// import juniperLogo from "../../../assets/juniper.svg";
import juniper_dark from "../../../assets/juniper_v4_dark.svg";
import juniperLogo from "../../../assets/juniper_v4_light.svg";
import misconfig from "../../../assets/misconfig.svg";
import orange_shield from "../../../assets/orange-shield.svg";
// import paloalto_assets from "../../../assets/paloalto-assets.svg";
// import paloalto_dark from "../../../assets/paloalto-white.svg";
import paloalto_assets from "../../../assets/paloalto3_v4_light.svg";
import paloalto_dark from "../../../assets/paloalto4_v4_dark.svg";
import red_shield from "../../../assets/red-shield.svg";
import red_bug from "../../../assets/red_bug.svg";
import green_bug from "../../../assets/green_bug.svg";
import xlsIcon from "../../../assets/xls.svg";
import axiosInstance from "../../../axios/axios";
import AssetComplianceReportDrawer from "../../../components/asset/AssetComplianceReportDrawer";
import AssetDetailsDrawer from "../../../components/asset/AssetDetailsDrawer";
import AgGridTable from "../../../components/table/AgGridTable";
// import CustomSetFilterComp from "../../../components/table/CustomSetFilterComp";
import eventEmitter from "../../../components/utils/eventEmitter";
import { END_POINTS } from "../../../shared";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import { useEncryptService } from "../../../shared/hooks";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import useFrameworks from "../../../shared/hooks/useFrameworks";
import { authActions } from "../../../store/authSlice";
import { setConfigDiffData } from "../ConfigDiff/ConfigDiff-slice";
import MapCredentialPopup from "./MapCredentialPopup";
import MapAssetTemplateDialog, {
  canMapTemplateToAsset,
} from "./MapAssetTemplateDialog";
import MapMultiAssetTemplateDialog from "./MapMultiAssetTemplateDialog";
import RescanWithCredentialPopup from "./RescanPopup";
import DiscoveryRescanPopup from "../../discovery/DiscoveryRescanPopup";
import xlsIcon_dark from "../../../assets/xlsIcon_dark.svg";
import downloadIcon_dark from "../../../assets/downloadIcon_dark.svg";
import "./AssetDetails.scss";
import fortinet_img from "../../../assets/fortinet.svg";
import fortinet_scan_dark from "../../../assets/fortinet-white-1.svg";
import CustomAssetDrawer from "./NewConfigSSH";
import SingleFileUploadDialog from "./SingleFileUploadDialog";
import {
  setIsBothCloudAndPremAssetUser,
  setIsNewUserTrue,
  setIsOnlyCloudUser,
  setIsOnlyPremAssetUser,
  resetUserTypeFlags,
} from "../../../modules/authentication/login/Login_Details_slice";

// 🚀 Global variables to store filter data for AG Grid filters
let globalDeviceTypes: string[] = [];
let globalVendors: string[] = [];
let globalModels: string[] = [];

const caseInsensitiveComparator = (valueA: any, valueB: any) => {
  const strA = valueA ? String(valueA).toLowerCase() : "";
  const strB = valueB ? String(valueB).toLowerCase() : "";
  return strA.localeCompare(strB, undefined, { numeric: true });
};


// 🚀 Custom Device Type Filter Component for AG Grid
const DeviceTypeFilter = React.forwardRef<any, any>((params, ref) => {
  const [selectedDeviceTypes, setSelectedDeviceTypes] = useState<string[]>([]);
  const [availableDeviceTypes, setAvailableDeviceTypes] = useState<string[]>(
    params.deviceTypes?.length ? params.deviceTypes : globalDeviceTypes
  );
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');

  // Filter device types based on search text
  const filteredDeviceTypes = React.useMemo(() => {
    if (!searchText.trim()) return availableDeviceTypes;
    return availableDeviceTypes.filter(deviceType =>
      deviceType.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [availableDeviceTypes, searchText]);

  // 🚀 Update available device types when params or global variable changes
  React.useEffect(() => {
    const typesToUse = params.deviceTypes?.length ? params.deviceTypes : globalDeviceTypes;
    setAvailableDeviceTypes([...typesToUse]);
  }, [params.deviceTypes]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => {
      const isActive = selectedDeviceTypes.length > 0 && !isAllSelected;
      return isActive;
    },

    doesFilterPass: (params: any) => {
      if (selectedDeviceTypes.length === 0 || isAllSelected) return true;
      const passes = selectedDeviceTypes.includes(params.data.device_type);
      return passes;
    },

    getModel: () => {
      return selectedDeviceTypes.length > 0 && !isAllSelected ? { selectedTypes: selectedDeviceTypes } : null;
    },

    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelectedDeviceTypes(model.selectedTypes);
        setIsAllSelected(false);
      } else {
        setSelectedDeviceTypes([]);
        setIsAllSelected(true);
      }
    },

    afterGuiAttached: () => {
      // Use global device types when filter is opened
      const typesToUse = params.deviceTypes?.length ? params.deviceTypes : globalDeviceTypes;
      setAvailableDeviceTypes([...typesToUse]);
    },

    getGui: () => {
      return null; // We return the JSX directly, not through getGui
    }
  }));

  const handleDeviceTypeToggle = (deviceType: string) => {
    if (deviceType === 'All') {
      setIsAllSelected(true);
      setSelectedDeviceTypes([]);
    } else {
      setIsAllSelected(false);
      const newSelected = selectedDeviceTypes.includes(deviceType)
        ? selectedDeviceTypes.filter(type => type !== deviceType)
        : [...selectedDeviceTypes, deviceType];

      setSelectedDeviceTypes(newSelected);
    }

    // Trigger AG Grid filter change immediately
    if (params.filterChangedCallback) {
      params.filterChangedCallback();
    }

    // Also trigger global event for consistency
    setTimeout(() => {
      if (params.api) {
        params.api.onFilterChanged();
      }
    }, 0);
  };

  const handleClear = () => {
    setSelectedDeviceTypes([]);
    setIsAllSelected(true);
    setSearchText('');
    // Clear global filter state
    (window as any).deviceTypeFilter = [];
    // Trigger grid refresh through global event
    window.dispatchEvent(new CustomEvent('deviceTypeFilterChanged', {
      detail: { selectedTypes: [] }
    }));
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div style={{
      padding: '12px',
      minWidth: '240px',
      maxWidth: '260px',
      backgroundColor: isDarkTheme ? '#2d3748' : '#ffffff',
      border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
      borderRadius: '6px',
      boxShadow: isDarkTheme ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '13px'
    }}>
      <div style={{
        marginBottom: '12px',
        fontWeight: '500',
        color: isDarkTheme ? '#f7fafc' : '#2d3748',
        fontSize: '13px'
      }}>
        Filter Device Types
      </div>

      {/* Search Input */}
      <div style={{ marginBottom: '12px' }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: '100%',
            padding: '6px 8px',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            backgroundColor: isDarkTheme ? '#1a202c' : '#ffffff',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            outline: 'none',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#0969da';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = isDarkTheme ? '#444444' : '#d0d7de';
          }}
        />
      </div>

      <div style={{
        maxHeight: '200px',
        overflowY: 'auto',
        marginBottom: '12px'
      }}>
        {/* All option */}
        <div
          key="All"
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 8px',
            cursor: 'pointer',
            backgroundColor: isAllSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
            borderRadius: '4px',
            marginBottom: '2px',
            fontWeight: isAllSelected ? '500' : '400',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            transition: 'background-color 0.2s'
          }}
          onClick={() => handleDeviceTypeToggle('All')}
          onMouseEnter={(e) => {
            if (!isAllSelected) {
              e.currentTarget.style.backgroundColor = isDarkTheme ? '#4a5568' : '#f7fafc';
            }
          }}
          onMouseLeave={(e) => {
            if (!isAllSelected) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
        >
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={() => handleDeviceTypeToggle('All')}
            style={{ marginRight: '8px' }}
          />
          <span>All</span>
        </div>

        {filteredDeviceTypes.length > 0 ? (
          filteredDeviceTypes.map((deviceType: string) => {
            const isSelected = selectedDeviceTypes.includes(deviceType);
            return (
              <div
                key={deviceType}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '6px 8px',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
                  borderRadius: '4px',
                  marginBottom: '2px',
                  color: isDarkTheme ? '#f7fafc' : '#2d3748',
                  fontSize: '13px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => handleDeviceTypeToggle(deviceType)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = isDarkTheme ? '#4a5568' : '#f7fafc';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleDeviceTypeToggle(deviceType)}
                  style={{
                    marginRight: '8px'
                  }}
                />
                <span>{deviceType}</span>
              </div>
            );
          })
        ) : availableDeviceTypes.length === 0 ? (
          <div style={{ color: isDarkTheme ? '#a0aec0' : '#718096', fontStyle: 'italic', padding: '8px' }}>
            Loading device types...
          </div>
        ) : (
          <div style={{ color: isDarkTheme ? '#a0aec0' : '#718096', fontStyle: 'italic', padding: '8px' }}>
            No device types found matching
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={handleClear}
          style={{
            padding: '6px 12px',
            backgroundColor: 'transparent',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            cursor: 'pointer',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px'
          }}
        >
          Clear
        </button>
        <button
          onClick={() => {
            // Set global filter state that the main component can use
            (window as any).deviceTypeFilter = isAllSelected ? [] : selectedDeviceTypes;
            // Trigger grid refresh through global event
            window.dispatchEvent(new CustomEvent('deviceTypeFilterChanged', {
              detail: { selectedTypes: isAllSelected ? [] : selectedDeviceTypes }
            }));
            // close AG Grid filter popup
            params.api?.hidePopupMenu?.();
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#0969da',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

// 🚀 Custom Vendor Filter Component for AG Grid
const VendorFilter = React.forwardRef<any, any>((params, ref) => {
  const [selectedVendors, setSelectedVendors] = useState<string[]>([]);
  const [availableVendors, setAvailableVendors] = useState<string[]>(
    params.vendors?.length ? params.vendors : globalVendors
  );
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');

  // Filter vendors based on search text
  const filteredVendors = React.useMemo(() => {
    if (!searchText.trim()) return availableVendors;
    return availableVendors.filter(vendor =>
      vendor.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [availableVendors, searchText]);

  // Update available vendors when params or global variable changes
  React.useEffect(() => {
    const vendorsToUse = params.vendors?.length ? params.vendors : globalVendors;
    setAvailableVendors([...vendorsToUse]);
  }, [params.vendors]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => {
      const isActive = selectedVendors.length > 0 && !isAllSelected;
      return isActive;
    },

    doesFilterPass: (params: any) => {

      if (selectedVendors.length === 0 || isAllSelected) {
        return true;
      }

      const passes = selectedVendors.includes(params.data.vendor);
      return passes;
    },

    getModel: () => {
      return selectedVendors.length > 0 && !isAllSelected ? { selectedTypes: selectedVendors } : null;
    },

    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelectedVendors(model.selectedTypes);
        setIsAllSelected(false);
      } else {
        setSelectedVendors([]);
        setIsAllSelected(true);
      }
    },

    afterGuiAttached: () => {
      const vendorsToUse = params.vendors?.length ? params.vendors : globalVendors;
      setAvailableVendors([...vendorsToUse]);
    },

    getGui: () => {
      return null;
    }
  }));

  const handleVendorToggle = (vendor: string) => {
    if (vendor === 'All') {
      setIsAllSelected(true);
      setSelectedVendors([]);
    } else {
      setIsAllSelected(false);
      const newSelected = selectedVendors.includes(vendor)
        ? selectedVendors.filter(type => type !== vendor)
        : [...selectedVendors, vendor];

      setSelectedVendors(newSelected);
    }

    // Trigger AG Grid filter change immediately
    setTimeout(() => {
      if (params.api) {
        params.api.onFilterChanged();
      }
    }, 0);
  };

  const handleClear = () => {
    setSelectedVendors([]);
    setIsAllSelected(true);
    setSearchText('');
    (window as any).vendorFilter = [];
    window.dispatchEvent(new CustomEvent('vendorFilterChanged', {
      detail: { selectedTypes: [] }
    }));
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div style={{
      padding: '12px',
      minWidth: '240px',
      maxWidth: '260px',
      backgroundColor: isDarkTheme ? '#2d3748' : '#ffffff',
      border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
      borderRadius: '6px',
      boxShadow: isDarkTheme ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '13px'
    }}>
      <div style={{
        marginBottom: '12px',
        fontWeight: '500',
        color: isDarkTheme ? '#f7fafc' : '#2d3748',
        fontSize: '13px'
      }}>
        Filter Vendors
      </div>

      {/* Search Input */}
      <div style={{ marginBottom: '12px' }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: '100%',
            padding: '6px 8px',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            backgroundColor: isDarkTheme ? '#1a202c' : '#ffffff',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            outline: 'none',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#3182ce';
            e.target.style.boxShadow = `0 0 0 1px ${isDarkTheme ? '#63b3ed' : '#3182ce'}`;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = isDarkTheme ? '#4a5568' : '#e2e8f0';
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>

      <div style={{
        maxHeight: '200px',
        overflowY: 'auto',
        marginBottom: '12px'
      }}>
        {/* All option */}
        <div
          key="All"
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 8px',
            cursor: 'pointer',
            backgroundColor: isAllSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
            borderRadius: '4px',
            marginBottom: '2px',
            fontWeight: isAllSelected ? '500' : '400',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            transition: 'background-color 0.2s'
          }}
          onClick={() => handleVendorToggle('All')}
          onMouseEnter={(e) => {
            if (!isAllSelected) {
              e.currentTarget.style.backgroundColor = isDarkTheme ? '#4a5568' : '#f7fafc';
            }
          }}
          onMouseLeave={(e) => {
            if (!isAllSelected) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
        >
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={() => handleVendorToggle('All')}
            style={{ marginRight: '8px', accentColor: isDarkTheme ? '#3182ce' : '#3182ce' }}
          />
          <span>All</span>
        </div>

        {filteredVendors.length > 0 ? (
          filteredVendors.map((vendor: string) => {
            const isSelected = selectedVendors.includes(vendor);
            return (
              <div
                key={vendor}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '6px 8px',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
                  borderRadius: '4px',
                  marginBottom: '2px',
                  color: isDarkTheme ? '#f7fafc' : '#2d3748',
                  fontSize: '13px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => handleVendorToggle(vendor)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = isDarkTheme ? '#4a5568' : '#f7fafc';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleVendorToggle(vendor)}
                  style={{
                    marginRight: '8px',
                    accentColor: isDarkTheme ? '#3182ce' : '#3182ce'
                  }}
                />
                <span>{vendor}</span>
              </div>
            );
          })
        ) : availableVendors.length === 0 ? (
          <div style={{ color: isDarkTheme ? '#a0aec0' : '#718096', fontStyle: 'italic', padding: '8px' }}>
            Loading vendors...
          </div>
        ) : (
          <div style={{ color: isDarkTheme ? '#a0aec0' : '#718096', fontStyle: 'italic', padding: '8px' }}>
            No vendors found matching
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={handleClear}
          style={{
            padding: '6px 12px',
            backgroundColor: 'transparent',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            cursor: 'pointer',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = isDarkTheme ? '#4a5568' : '#f7fafc';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          Clear
        </button>
        <button
          onClick={() => {
            (window as any).vendorFilter = isAllSelected ? [] : selectedVendors;
            window.dispatchEvent(new CustomEvent('vendorFilterChanged', {
              detail: { selectedTypes: isAllSelected ? [] : selectedVendors }
            }));
            params.api?.hidePopupMenu?.();
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#3182ce',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2c5aa0';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#3182ce';
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

// 🚀 Custom Model Filter Component for AG Grid
const ModelFilter = React.forwardRef<any, any>((params, ref) => {
  const [selectedModels, setSelectedModels] = useState<string[]>([]);
  const [availableModels, setAvailableModels] = useState<string[]>(
    params.models?.length ? params.models : globalModels
  );
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');

  // Filter models based on search text
  const filteredModels = React.useMemo(() => {
    if (!searchText.trim()) return availableModels;
    return availableModels.filter(model =>
      model.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [availableModels, searchText]);

  // Update available models when params or global variable changes
  React.useEffect(() => {
    const modelsToUse = params.models?.length ? params.models : globalModels;
    setAvailableModels([...modelsToUse]);
  }, [params.models]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => {
      const isActive = selectedModels.length > 0 && !isAllSelected;
      return isActive;
    },

    doesFilterPass: (params: any) => {
      if (selectedModels.length === 0 || isAllSelected) {
        return true;
      }

      const passes = selectedModels.includes(params.data.model);
      return passes;
    },

    getModel: () => {
      return selectedModels.length > 0 && !isAllSelected ? { selectedTypes: selectedModels } : null;
    },

    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelectedModels(model.selectedTypes);
        setIsAllSelected(false);
      } else {
        setSelectedModels([]);
        setIsAllSelected(true);
      }
    },

    afterGuiAttached: () => {
      const modelsToUse = params.models?.length ? params.models : globalModels;
      setAvailableModels([...modelsToUse]);
    },

    getGui: () => {
      return null;
    }
  }));

  const handleModelToggle = (model: string) => {
    if (model === 'All') {
      setIsAllSelected(true);
      setSelectedModels([]);
    } else {
      setIsAllSelected(false);
      const newSelected = selectedModels.includes(model)
        ? selectedModels.filter(type => type !== model)
        : [...selectedModels, model];

      setSelectedModels(newSelected);
    }

    // Trigger AG Grid filter change immediately
    setTimeout(() => {
      if (params.api) {
        params.api.onFilterChanged();
      }
    }, 0);
  };

  const handleClear = () => {
    setSelectedModels([]);
    setIsAllSelected(true);
    setSearchText('');
    (window as any).modelFilter = [];
    window.dispatchEvent(new CustomEvent('modelFilterChanged', {
      detail: { selectedTypes: [] }
    }));
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div style={{
      padding: '12px',
      minWidth: '240px',
      maxWidth: '260px',
      backgroundColor: isDarkTheme ? '#2d3748' : '#ffffff',
      border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
      borderRadius: '6px',
      boxShadow: isDarkTheme ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '13px'
    }}>
      <div style={{
        marginBottom: '12px',
        fontWeight: '500',
        color: isDarkTheme ? '#f7fafc' : '#2d3748',
        fontSize: '13px'
      }}>
        Filter Models
      </div>

      {/* Search Input */}
      <div style={{ marginBottom: '12px' }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: '100%',
            padding: '6px 8px',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            backgroundColor: isDarkTheme ? '#1a202c' : '#ffffff',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            outline: 'none',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#3182ce';
            e.target.style.boxShadow = `0 0 0 1px ${isDarkTheme ? '#63b3ed' : '#3182ce'}`;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = isDarkTheme ? '#4a5568' : '#e2e8f0';
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>

      <div style={{
        maxHeight: '200px',
        overflowY: 'auto',
        marginBottom: '12px'
      }}>
        {/* All option */}
        <div
          key="All"
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 8px',
            cursor: 'pointer',
            backgroundColor: isAllSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
            borderRadius: '4px',
            marginBottom: '2px',
            fontWeight: isAllSelected ? '500' : '400',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px',
            transition: 'background-color 0.2s'
          }}
          onClick={() => handleModelToggle('All')}
        >
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={() => handleModelToggle('All')}
            style={{ marginRight: '8px' }}
          />
          <span>All</span>
        </div>

        {filteredModels.length > 0 ? (
          filteredModels.map((model: string) => {
            const isSelected = selectedModels.includes(model);
            return (
              <div
                key={model}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '6px 8px',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent',
                  borderRadius: '4px',
                  marginBottom: '2px',
                  color: isDarkTheme ? '#f7fafc' : '#2d3748',
                  fontSize: '13px',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => handleModelToggle(model)}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleModelToggle(model)}
                  style={{
                    marginRight: '8px'
                  }}
                />
                <span>{model}</span>
              </div>
            );
          })
        ) : availableModels.length === 0 ? (
          <div style={{ fontStyle: 'italic' }}>
            Loading models...
          </div>
        ) : (
          <div style={{ fontStyle: 'italic' }}>
            No models found matching
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={handleClear}
          style={{
            padding: '6px 12px',
            backgroundColor: 'transparent',
            border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`,
            borderRadius: '4px',
            cursor: 'pointer',
            color: isDarkTheme ? '#f7fafc' : '#2d3748',
            fontSize: '13px'
          }}
        >
          Clear
        </button>
        <button
          onClick={() => {
            (window as any).modelFilter = isAllSelected ? [] : selectedModels;
            window.dispatchEvent(new CustomEvent('modelFilterChanged', {
              detail: { selectedTypes: isAllSelected ? [] : selectedModels }
            }));
            params.api?.hidePopupMenu?.();
          }}
          style={{
            padding: '6px 12px',
            backgroundColor: '#0969da',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

const isZeroOrEmpty = (val: any) => {
  if (val === undefined || val === null || val === "" || val === "-") return true;
  const num = Number(val);
  return !isNaN(num) && num === 0;
};

const AssetsDetailsV2 = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabFromQuery = searchParams.get("tab") === "cloud" ? "cloud" : "on_prem";
  const [environmentFilter, setEnvironmentFilter] = useState<"on_prem" | "cloud">(activeTabFromQuery);
  const intervalRequest = React.useRef<NodeJS.Timeout | null>(null);
  // ✅ Ref mirror of assetsRowData — always current inside timer callbacks (no stale closure)
  const assetsRowDataRef = React.useRef<any[]>([]);
  const assetListRequestRef = React.useRef<AbortController | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [assetsRowData, setAssetsRowData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [anchorElAction, setAnchorElAction] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorElAction);
  const [showDecommissioned, setShowDecommissioned] = useState(false);
  const [showPreviousResources, setShowPreviousResources] = useState(false);

  const handleTabChange = (tab: "on_prem" | "cloud") => {
    if (tab === environmentFilter) return;
    setEnvironmentFilter(tab);
    updateSelectedRows([]);
    const wasDecommissioned = showDecommissioned;
    setShowDecommissioned(false);
    setShowPreviousResources(false);

    // Reset active filters when switching environment tab
    setActiveFilters({
      device_type: [],
      vendor: [],
      model: []
    });
    (window as any).vendorFilter = [];
    (window as any).deviceTypeFilter = [];
    (window as any).modelFilter = [];
    window.dispatchEvent(new CustomEvent('vendorFilterChanged', { detail: { selectedTypes: [] } }));
    window.dispatchEvent(new CustomEvent('deviceTypeFilterChanged', { detail: { selectedTypes: [] } }));
    window.dispatchEvent(new CustomEvent('modelFilterChanged', { detail: { selectedTypes: [] } }));

    // If was showing decommissioned on-prem assets, reload active assets
    if (wasDecommissioned && environmentFilter === "on_prem") {
      fetchAssetsData();
    }

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", tab);
    setSearchParams(nextParams, { replace: true });
  };

  useEffect(() => {
    if (activeTabFromQuery !== environmentFilter) {
      setEnvironmentFilter(activeTabFromQuery);
      updateSelectedRows([]);
      setShowDecommissioned(false);
      setActiveFilters({
        device_type: [],
        vendor: [],
        model: []
      });
      (window as any).vendorFilter = [];
      (window as any).deviceTypeFilter = [];
      (window as any).modelFilter = [];
      window.dispatchEvent(new CustomEvent('vendorFilterChanged', { detail: { selectedTypes: [] } }));
      window.dispatchEvent(new CustomEvent('deviceTypeFilterChanged', { detail: { selectedTypes: [] } }));
      window.dispatchEvent(new CustomEvent('modelFilterChanged', { detail: { selectedTypes: [] } }));
    }
  }, [activeTabFromQuery]);

  const isCloudAsset = (row: any): boolean => {
    if (!row) return false;
    const vendorStr = String(row.vendor ?? "").toLowerCase().trim();
    const cloudStr = String(row.cloud ?? "").toLowerCase().trim();
    const typeStr = String(row.type ?? "").toLowerCase().trim();
    return (
      vendorStr === "amazon web services" ||
      vendorStr === "aws" ||
      vendorStr.includes("amazon") ||
      vendorStr.includes("aws") ||
      vendorStr.includes("azure") ||
      vendorStr.includes("gcp") ||
      vendorStr.includes("google cloud") ||
      cloudStr === "amazon web services" ||
      cloudStr.length > 0 ||
      typeStr === "cloud"
    );
  };

  const filteredAssetsRowData = useMemo(() => {
    if (!assetsRowData) return [];
    return assetsRowData.filter((row: any) => {
      const isCloud = isCloudAsset(row);
      const isLastScanStatusFalse =
        row?.last_scan_status === false ||
        String(row?.last_scan_status).toLowerCase() === "false";
      // AWS discovery inventory (and common discovery+posture rows) stay on the
      // active Cloud tab even when posture left last_scan_status false.
      const scanType = String(row?.scan_type || "").toLowerCase();
      const isAwsDiscoveryInventory =
        scanType === "aws_discovery" || scanType === "aws_discovery_posture";

      if (environmentFilter === "cloud") {
        if (!isCloud) return false;
        if (showDecommissioned) {
          // Showing decommissioned assets from DECOMM_DEVICE_LIST
          return true;
        }
        if (showPreviousResources) {
          // Showing previous scan resources (last scan status false)
          // Exclude aws discovery inventory — those belong on the main Cloud tab
          return isLastScanStatusFalse && !isAwsDiscoveryInventory;
        }
        // Active view: hide decommissioned and hide previous scan status false resources
        // Keep aws discovery resources visible alongside assessed posture assets
        if (isAwsDiscoveryInventory) {
          return !(
            row?.is_decommissioned === true ||
            String(row?.is_decommissioned).toLowerCase() === "true" ||
            row?.decommission_on ||
            row?.decommission_by
          );
        }
        return !(
          row?.is_decommissioned === true ||
          String(row?.is_decommissioned).toLowerCase() === "true" ||
          isLastScanStatusFalse ||
          row?.decommission_on ||
          row?.decommission_by
        );
      }

      if (environmentFilter === "on_prem") {
        return !isCloud;
      }

      return true;
    });
  }, [assetsRowData, environmentFilter, showDecommissioned, showPreviousResources]);

  // 🚀 Dynamically update unique filter options based on active environment (On-Prem vs Cloud)
  useEffect(() => {
    if (!filteredAssetsRowData) return;

    const deviceTypes = Array.from(
      new Set(
        filteredAssetsRowData
          .map((asset: any) => asset.device_type)
          .filter((type: string) => type && type.trim() !== "")
      )
    ).sort() as string[];

    const vendors = Array.from(
      new Set(
        filteredAssetsRowData
          .map((asset: any) => asset.vendor)
          .filter((vendor: string) => vendor && vendor.trim() !== "")
      )
    ).sort() as string[];

    const models = Array.from(
      new Set(
        filteredAssetsRowData
          .map((asset: any) => asset.model)
          .filter((model: string) => model && model.trim() !== "")
      )
    ).sort() as string[];

    setUniqueValues({
      device_type: deviceTypes,
      vendor: vendors,
      model: models
    });

    globalDeviceTypes = deviceTypes;
    globalVendors = vendors;
    globalModels = models;
  }, [filteredAssetsRowData]);

  const { hasPermissions } = useRolePermissions();
  const { isFrameworkOn, isFrameworkKeyOn } = useFrameworks();
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [reportFormat, setReportFormat] = useState("pdf");
  const [isDecommissionDialogOpen, setIsDecommissionDialogOpen] =
    useState(false);
  const [isUpdatingCriticality, setIsUpdatingCriticality] = useState(false);

  const updateSelectedRows = (rows: any[]) => {
    setSelectedRows(rows);
    if (!rows || rows.length === 0) {
      setAnchorElAction(null);
      if (gridApiRef.current && gridApiRef.current.api) {
        gridApiRef.current.api.deselectAll();
      }
    }
  };

  const reportEligibleAssets = useMemo(() => {
    return selectedRows.filter((asset: any) => {
      const type = asset?.type?.toLowerCase();
      const scanType = asset?.scan_type?.toLowerCase();
      return type !== "discovery" && scanType !== "discovery";
    });
  }, [selectedRows]);
  const [isCommissionDialogOpen, setIsCommissionDialogOpen] = useState(false);
  const [cloudCredentials, setCloudCredentials] = useState<any[]>([]);
  const [deviceIds, setDeviceIds] = useState<string[]>([]);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [openSidenav, setOpenSideNav] = React.useState(false);
  const [originalRegions, setOriginalRegions] = useState([]);
  const [commissionRowData, setCommissionRowData] = useState<any>();

  React.useEffect(() => {
    if (isCommissionDialogOpen) {
      axiosInstance
        .get(`${END_POINTS.CREDENTIAL_MGMT}?type=aws`)
        .then((res: any) => {
          setCloudCredentials(res.data?.data?.cred_list || []);
        })
        .catch((err: any) => {
          console.error("Error fetching AWS credentials:", err);
        });
    }
  }, [isCommissionDialogOpen]);
  const [currentRegions, setCurrentRegions] = useState<any>([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [isFirstPopupOpen, setIsFirstPopupOpen] = useState(false);
  const [isSecondPopupOpen, setIsSecondPopupOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("0");
  const [selectedscheduleOption, setScheduleSelectedOption] =
    useState("new_schedule");
  const [scheduleOptionsWeekly, setScheduleOptionsWeekly] = useState([]);
  const [scheduleOptionsFrequency, setScheduleOptionsFrequency] = useState([]);
  const [isallScheduleable, setIsAllScheduleable] = useState(false);
  const [scanSummaryData, setScanSummaryData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [isCancelSchedulePopupOpen, setIsCancelSchedulePopupOpen] =
    useState(false);
  const [removeAllSchedules, setRemoveAllSchedules] = useState(false);
  const [assetsCredData, setAssetsCredData] = useState([]);
  const [assetCriticalityData, setAssetCriticalityData] = useState([]);
  const [assetCriticalityOptions, setAssetCriticalityOptions] = useState<any>(
    []
  );
  const [credTypes, setCredtypes] = useState([]);
  const [isRescanPopupOpen, setIsRescanPopupOpen] = useState(false);
  const [isDiscoveryRescanOpen, setIsDiscoveryRescanOpen] = useState(false);
  const [discoveryRescanRowData, setDiscoveryRescanRowData] = useState<any>(null);
  const [cloudAgents, setCloudAgents] = useState<any[]>([]);

  const isAssetAgentInactive = (asset: any) => {
    const agentId = asset?.agent_id || asset?.agentId;
    if (!agentId) return false;
    const agent = cloudAgents?.find((a: any) => a.id === agentId);
    if (!agent) return false;
    const status = String(agent.status_display ?? agent.status ?? "").toLowerCase();
    return status === "inactive" || status === "unenrolled";
  };

  const [hasActiveAgent, setHasActiveAgent] = useState<boolean | null>(null);
  const [isMapCredentialPopupOpen, setIsMapCredentialPopupOpen] =
    useState(false);
  const [isMapTemplateDialogOpen, setIsMapTemplateDialogOpen] = useState(false);
  const [mapTemplateDevices, setMapTemplateDevices] = useState<any[]>([]);
  const [isAssetCriticalityDialogOpen, setIsAssetCriticalityDialogOpen] =
    useState(false);
  const [latestRescanDevicesList, setLatestRescanDevicesList] = useState<
    string[]
  >([]);
  const [rescanResponseData, setRescanResponseData] = useState<any>();
  const [assetDrawerOpen, setAssetDrawerOpen] = useState(false);
  const [selectedAssetSideNav, setSelectedAssetSideNav] = useState<any>(null);
  const [scheduledTableInfo, setScheduledTableInfo] = useState<any>(null);
  const [selectedCriticalId, setSelectAssetsCriticaledId] = useState<any>("");
  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { doEncryptLogin } = useEncryptService();
  let url = END_POINTS.DEVICE_LIST_V2;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const lastErrorMessageRef = React.useRef<string | null>(null);
  const toastTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
  const toastDuration = 5000;
  const [popoverPosition, setPopoverPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const gridApiRef = useRef<any>(null);
  // const onGridReady = (params: any) => {
  //   gridApiRef.current = params.api;
  // };

  const [isCalenderIconClicked, setIsCalenderIconClicked] = useState(false);
  const [isTableParams, setIsTableParams] = useState(null);

  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLElement>(null);
  const [popoverRow, setPopoverRow] = useState<any>(null);
  const [showRadioOptions, setShowRadioOptions] = useState(false);
  const [selectedCriticality, setSelectedCriticality] = useState("");
  const [showRecommissionOptions, setShowRecommissionOptions] = useState(false);
  const [selectedRecommissionOption, setSelectedRecommissionOption] =
    useState("");
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [selectedSSHAPIOption, setSelectedSSHAAPIOption] = useState("");
  const [showSSHAPIOptions, setShowSSHAPIOptions] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isSimplifiedRecommissionAsset = (asset: any) => {
    const vendor = asset?.vendor?.toLowerCase().replace(/[\s_-]/g, "");
    const isEndpoint = asset?.device_type?.toLowerCase() === "endpoint";
    return isEndpoint || ["huawei", "mikrotik", "edgecore", "tp-link", "tplink", "dell", "syrotech"].includes(vendor);
  };

  // 🚀 Generic Filter System - Much cleaner approach!
  const [uniqueValues, setUniqueValues] = useState<Record<string, string[]>>({
    device_type: [],
    vendor: [],
    model: []
  });

  const [activeFilters, setActiveFilters] = useState<Record<string, string[]>>({
    device_type: [],
    vendor: [],
    model: []
  });

  // 🚀 Generic filter change handler
  const handleFilterChange = (filterType: string, selectedValues: string[]) => {
    setActiveFilters(prev => ({
      ...prev,
      [filterType]: selectedValues
    }));
  };

  // 🚀 Listen for filter changes from custom filter components
  useEffect(() => {
    const handleDeviceTypeFilterChange = (event: any) => {
      handleFilterChange('device_type', event.detail.selectedTypes);
    };

    const handleVendorFilterChange = (event: any) => {
      handleFilterChange('vendor', event.detail.selectedTypes);
    };

    const handleModelFilterChange = (event: any) => {
      handleFilterChange('model', event.detail.selectedTypes);
    };

    window.addEventListener('deviceTypeFilterChanged', handleDeviceTypeFilterChange);
    window.addEventListener('vendorFilterChanged', handleVendorFilterChange);
    window.addEventListener('modelFilterChanged', handleModelFilterChange);

    return () => {
      window.removeEventListener('deviceTypeFilterChanged', handleDeviceTypeFilterChange);
      window.removeEventListener('vendorFilterChanged', handleVendorFilterChange);
      window.removeEventListener('modelFilterChanged', handleModelFilterChange);
    };
  }, []);

  type PasswordType = {
    id: string;
    code: string;
    name: string;
  };
  type CredentialType = {
    id: string;
    code: string;
    name: string;
    password_type: PasswordType[];
  };
  const [credentialsTypes, setCredentialsTypes] = useState<CredentialType[]>(
    []
  );

  //const refreshAPIData = useSelector((state: any) => state.refreshPage.actionDataList);

  // useEffect(()=> {
  //   if (refreshAPIData && refreshAPIData.length > 0) {
  //     fetchAssetsData();
  //   }
  // },[refreshAPIData])

  const handleSSHUpload = async (formData: any) => {
    const payload: any = {
      rescan_type: "new_config",
      device_id: deviceIds[0],
      scan_type: formData?.credentialType,
      host: doEncryptLogin(formData?.assetIp),
    };

    if (formData?.agentId || formData?.agent_id) {
      payload.agent_id = formData?.agentId || formData?.agent_id;
    }

    if (formData?.credentialType === "ssh") {
      if (formData?.credentialSelect === "Create New Credential") {
        Object.assign(payload, {
          encrypt: "true",
          new_cred: true,
          user_id: "[]",
          role_id: "[]",
          save: "true",
          global_cred: "false",
          username: doEncryptLogin(formData?.username),
          description: formData?.description,
          cred_name: formData?.credName,
          loginParameter: formData?.passwordType,
          custom_port: formData?.customPort,
        });

        if (formData?.customPort) {
          payload.custom_port_number = formData?.customPortNumber;
        }

        if (credentialsTypes.length > 0 && credentialsTypes[0].password_type) {
          const type: any = credentialsTypes[0].password_type.find(
            (type: { code: string }) => type.code === passwordType
          );
          if (type) {
            payload.credential_type_id = type.id;
          }
        }

        if (formData?.passwordType === "password") {
          payload.password = doEncryptLogin(formData?.password);
          if (formData?.autoAssign) {
            payload.auto_assign = formData?.autoAssign;
          } else {
            payload.exec_password = formData?.execPassword;
            payload.enable_password = doEncryptLogin(
              formData?.execPasswordText
            );
          }
        }
      } else {
        payload.cred_id = formData?.credentialSelect;
        payload.encrypt = "true";
      }
    } else if (formData?.credentialType === "windows") {
      if (formData?.credentialSelect === "Create New Credential") {
        Object.assign(payload, {
          encrypt: "true",
          new_cred: true,
          user_id: "[]",
          role_id: "[]",
          save: "true",
          global_cred: "false",
          username: doEncryptLogin(formData?.username),
          password: doEncryptLogin(formData?.password),
          description: formData?.description || "",
          cred_name: formData?.credName,
          custom_port: formData?.customPort,
          auto_assign: true,
          exec_password: false,
        });

        if (formData?.customPort) {
          payload.custom_port_number = formData?.customPortNumber;
        }

        const windowsTypeObj = credentialsTypes
          .find((type: any) => type.code === "windows")
          ?.password_type?.find(
            (type: { code: string }) => type.code === "password"
          );
        if (windowsTypeObj) {
          payload.credential_type_id = windowsTypeObj.id;
        }
      } else {
        payload.cred_id = formData?.credentialSelect;
        payload.encrypt = "true";
      }
    } else {
      if (formData?.credentialSelect === "Create New Credential") {
        Object.assign(payload, {
          save: "true",
          cred_name: formData?.credName,
          api_token: doEncryptLogin(formData?.apiToken),
        });
      } else {
        payload.cred_id = formData?.credentialSelect;
        payload.encrypt = "true";
      }
    }
    try {
      const fileUploadResponse = await axiosInstance.post(
        END_POINTS.RESCAN_RECOMMISSION,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (fileUploadResponse?.status === 200) {
        toast.success(
          fileUploadResponse?.data?.message || "Asset recommissioned successfully!"
        );
        setShowDecommissioned(false);
        setDrawerOpen(false);
        fetchAssetsData();
        if (commissionRowData.scan_source === "file") {
          setShowRecommissionOptions(false);
          setSelectedRecommissionOption("");
        } else {
          setShowSSHAPIOptions(false);
          setSelectedSSHAAPIOption("");
        }
        setShowUploadDialog(false);
        updateSelectedRows([]);
        assetCount();
      } else {
        toast.error(
          fileUploadResponse?.data?.message || "Failed to recommission asset.",
          { type: "error" }
        );
      }
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.data?.message ||
        error?.response?.data?.message ||
        "Request failed";
      toast.error(errorMsg);
    }
  };
  const [credential_type_id, setCredentialTypeId] = useState<any | null>(null);
  const [passwordType, setPasswordType] = useState("none");
  const handlePasswordTypeChange = (event: any) => {
    setPasswordType(event.target.value);
    if (credentialsTypes.length > 0 && credentialsTypes[0].password_type) {
      const type: any = credentialsTypes[0].password_type.find(
        (type: { code: string }) => type.code === event.target.value
      );
      if (type) {
        setCredentialTypeId(type.id);
      }
    }
  };

  const fetchCredentialstypes = async () => {
    try {
      const response = await axiosInstance.get(
        `securityscan/credential-types`
      );
      const credList = response.data?.data || [];
      setCredentialsTypes(credList); // Set the fetched credentials list
    } catch (error) {
      toast.error("Error fetching credentials Types");
    }
  };

  const handleUpload = async (formData: FormData) => {
    try {
      // Your upload logic here, e.g.:
      formData.append("rescan_type", "new_config");
      formData.append("scan_type", "file");
      formData.append("device_id", deviceIds[0]);
      const fileUploadResponse = await axiosInstance.post(
        END_POINTS.RESCAN_RECOMMISSION,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (fileUploadResponse?.status === 200) {
        if (fileUploadResponse?.data?.data?.recommission === false) {
          toast.error("Recommission failed!");
        } else {
          toast.success("Recommission successful!");
        }
        setShowDecommissioned(false);
        setShowUploadDialog(false);
        fetchAssetsData();
        if (commissionRowData.scan_source === "file") {
          setShowRecommissionOptions(false);
          setSelectedRecommissionOption("");
        } else {
          setShowSSHAPIOptions(false);
          setSelectedSSHAAPIOption("");
        }
        setShowUploadDialog(false);
        updateSelectedRows([]);
      } else if (fileUploadResponse?.status === 400) {
        toast.error("Recommission failed!");
      } else {
        toast.error(
          fileUploadResponse?.data?.message || "Failed to upload file.",
          { type: "error" }
        );
      }
    } catch (error: any) {
      // Handle 400 status in error response
      if (error?.response?.status === 400) {
        toast.error("Recommission failed!");
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to upload config file.",
          { type: "error" }
        );
      }
    }
    // Show toast or handle response as needed
  };

  const handleCredential = async () => {
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response?.status === 200) {
        setAssetsCredData(response?.data?.data?.cred_list);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleRecommissionOptionSelect = async (option: string) => {
    setSelectedRecommissionOption(option);
    setShowRecommissionOptions(false);
    if (option === "upload") {
      // Open file upload dialog
      setShowUploadDialog(true);
    } else if (option === "ssh") {
      // Open SSH/API info dialog
      handleCredential();
      setDrawerOpen(true);
    } else if (option === "previous") {
      try {
        const handlePreviousResourceResponse = await axiosInstance.post(
          END_POINTS.RESCAN_RECOMMISSION,
          {
            device_id: deviceIds[0],
            rescan_type: "previous_config",
            scan_type: "file",
          }
        );
        if (handlePreviousResourceResponse?.status === 200) {
          toast.success("Recommission successful!");
          // if (handlePreviousResourceResponse?.data?.data?.message === "Previous config rescan initiated") {
          //   toast.success("Recommission successful!");
          // } else {
          //   toast.error("Recommission failed!");
          // }
          setShowDecommissioned(false);
          fetchAssetsData();
          setShowRecommissionOptions(false);
          setSelectedRecommissionOption("");
          updateSelectedRows([]);
        } else {
          toast.error(
            handlePreviousResourceResponse?.data?.message || "Failed to recommission asset.",
            { type: "error" }
          );
        }
      } catch (error: any) {
        toast.error(
          error.response?.data?.message || "Something went wrong",
          { type: "error" }
        );
      }
    } else if (option === "cancel") {
      // Close everything or reset
      setIsCommissionDialogOpen(false);
      setSelectedRecommissionOption("");
      formikCommission.resetForm();
    }
  };

  const handleRecommissionOptionSSHSelect = async (option: string) => {
    setSelectedSSHAAPIOption(option);
    setShowSSHAPIOptions(false);
    if (option === "previous_config_ssh_api") {
      try {
        const handlePreviousResourceResponse = await axiosInstance.post(
          END_POINTS.RESCAN_RECOMMISSION,
          {
            device_id: deviceIds[0],
            rescan_type: "new_config",
            scan_type: "ssh",
            exist_conn_details: "true",
          }
        );
        if (handlePreviousResourceResponse?.status === 200) {
          toast.success("Recommission successful!");
          // if (handlePreviousResourceResponse?.data?.data?.message === "Previous config rescan initiated") {
          //   toast.success("Recommission successful!");
          // } else {
          //   toast.error("Recommission failed!");
          // }
          setShowDecommissioned(false);
          fetchAssetsData();
          setShowSSHAPIOptions(false);
          setSelectedSSHAAPIOption("");
          updateSelectedRows([]);
        } else {
          toast.error(
            handlePreviousResourceResponse?.data?.message || "Failed to recommission asset.",
            { type: "error" }
          );
        }
      } catch (error: any) {
        toast.error(
          error.response?.data?.message || "Something went wrong",
          { type: "error" }
        );
      }
    } else if (option === "new_config_ssh_api") {
      // Open SSH/API info dialog
      handleCredential();
      setDrawerOpen(true);
    } else if (option === "new_config_upload") {
      setShowUploadDialog(true);
    } else if (option === "rescan_old_config") {
      try {
        const handlePreviousResourceResponse = await axiosInstance.post(
          END_POINTS.RESCAN_RECOMMISSION,
          {
            device_id: deviceIds[0],
            rescan_type: "previous_config",
            scan_type: "ssh",
          }
        );
        if (handlePreviousResourceResponse?.status === 200) {
          toast.success("Recommission successful!");
          // if (handlePreviousResourceResponse?.data?.data?.message === "Previous config rescan initiated") {
          //   toast.success("Recommission successful!");
          // } else {
          //   toast.error("Recommission failed!");
          // }
          setShowDecommissioned(false);
          fetchDecommsionedAssetsData();
          fetchAssetsData();
          setShowSSHAPIOptions(false);
          setSelectedSSHAAPIOption("");
          updateSelectedRows([]);
        } else {
          toast.error(
            handlePreviousResourceResponse?.data?.message || "Failed to recommission asset.",
            { type: "error" }
          );
        }
      } catch (error: any) {
        toast.error(
          error.response?.data?.message || "Something went wrong",
          { type: "error" }
        );
      }
    } else if (option === "cancel") {
      // Close everything or reset
      setShowSSHAPIOptions(false);
      setSelectedSSHAAPIOption("");
      formikCommission.resetForm();
    }
  };

  const handleApply = async () => {
    if (isUpdatingCriticality) return;
    setIsUpdatingCriticality(true);
    
    const selectedCriticalityId = assetCriticalityOptions.find(
      (find: { label: string }) => find.label === selectedCriticality
    )?.id;
    
    if (popoverRow && selectedCriticalityId !== undefined) {
      await singleHandleAssetCriticality(popoverRow, selectedCriticalityId);
    }
    
    setPopoverAnchor(null);
    setPopoverRow(null);
    setSelectedCriticality("");
    setShowRadioOptions(false);
    setIsUpdatingCriticality(false);
  };

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    row: any
  ) => {
    if (isCloudAsset(row)) return;
    setPopoverAnchor(event.currentTarget);
    setPopoverRow(row);
    setPopoverPosition({
      top: event.clientY,
      left: event.clientX,
    });
    setSelectedCriticality(row?.criticality || "");
  };
  const handlePopoverClose = () => {
    setPopoverAnchor(null);
    setPopoverRow(null);
    setSelectedCriticality("");
    setShowRadioOptions(false);
  };
  const criticalityColors: any = {
    critical: "#B71E31",
    high: "#FF6600",
    medium: "#E0B102",
    low: "#00A61B",
    default: "#B71E31",
  };
  const getLabelText = (value: any) => {
    const option = assetCriticalityOptions.find(
      (o: any) => o.label === value?.criticality
    );
    return option?.label || "Unknown";
  };

  const popoverContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "10px 13px",
        gap: 2,
        boxShadow: 3,
        borderRadius: 2,
        // minWidth: 200,
      }}
    // data-model-id="54666:1949"
    // onMouseLeave={handlePopoverClose}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          sx={{
            fontFamily: "Manrope, Helvetica",
            fontWeight: 700,
            // color: "#666291",
            fontSize: "0.75rem",
            lineHeight: "20px",
          }}
        >
          {popoverRow?.device_name} :{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "#f3f3f3",
            px: 1,
            py: 0.5,
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor:
                criticalityColors[popoverRow?.criticality?.toLowerCase()] ||
                "goldenrod",
              mr: 0.5,
            }}
          />
          <Typography
            sx={{
              fontFamily: "Geologica, Helvetica, sans-serif",
              fontWeight: 600,
              color:
                criticalityColors[popoverRow?.criticality?.toLowerCase()] ||
                "goldenrod",
              fontSize: "12px",
            }}
          >
            {getLabelText(popoverRow)}
          </Typography>
        </Box>
      </Stack>
      <Divider sx={{ width: "100%" }} />
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          onClick={() => {
            setShowRadioOptions(!showRadioOptions);
          }}
        >
          <Settings sx={{ width: 16, height: 16 }} />
          <Typography
            sx={{
              fontFamily: "Manrope, Helvetica",
              fontWeight: 500,
              // color: "#585874",
              fontSize: "0.75rem",
            }}
          >
            Set Asset Criticality
          </Typography>
        </Stack>
        {showRadioOptions && (
          <RadioGroup
            value={selectedCriticality}
            onChange={(e) => setSelectedCriticality(e.target.value)}
          >
            {assetCriticalityOptions.map((option: any) => (
              <FormControlLabel
                key={option.label}
                value={option.label}
                control={<Radio size="small" />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "Manrope, Helvetica",
                      fontWeight: 500,
                      // color: "#555b7d" ,
                      fontSize: "0.75rem",
                      opacity: 0.8,
                    }}
                  >
                    {option.label}
                  </Typography>
                }
                sx={{ marginBottom: 0.5 }}
              />
            ))}
          </RadioGroup>
        )}
        {showRadioOptions && (
          <Button
            onClick={() => {
              handleApply();
              // handlePopoverClose();
            }}
            disabled={selectedCriticality === "" || isUpdatingCriticality}
            variant="contained"
            sx={{
              // width: "156px",
              height: "21px",
              textTransform: "none",
              fontSize: "10px",
              fontFamily: "Roboto, Helvetica",
              borderRadius: "5px",
              bgcolor: "#4338ca",
              "&:hover": {
                bgcolor: "#3730a3",
              },
            }}
          >
            Apply
          </Button>
        )}
      </Stack>
    </Box>
  );

  // const ScheduledTable = ({ scheduledTableInfo, tableHeading }: any) => {
  //   return (
  //     <Box>
  //       <Typography variant="h6" sx={{ mb: 2 }}>
  //         Schedule Information - {tableHeading}
  //       </Typography>

  //       <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
  //         <Table stickyHeader>
  //           <TableHead>
  //             <TableRow>
  //               <TableCell>#</TableCell>
  //               <TableCell>Scan Name</TableCell>
  //               <TableCell>Frequency</TableCell>
  //               <TableCell>Schedule</TableCell>
  //               <TableCell>Time</TableCell>
  //             </TableRow>
  //           </TableHead>
  //           <TableBody>
  //             {scheduledTableInfo && scheduledTableInfo.map((row: any, index: number) => (
  //               <TableRow key={index}>
  //                 <TableCell>{index + 1}</TableCell>
  //                 <TableCell>{row.Scan_Name}</TableCell>
  //                 <TableCell>{row.Frequency}</TableCell>
  //                 <TableCell>{row.Schedule}</TableCell>
  //                 <TableCell>{row.Time}</TableCell>
  //               </TableRow>
  //             ))}
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     </Box>
  //   );
  // };

  const ScheduledTable = ({ scheduledTableInfo, tableHeading }: any) => {
    const cellStyle = {
      fontSize: "14px",
      fontWeight: 500,
      color: "#1A1A1A",
      lineHeight: "20px",
      height: 48,
      borderBottom: "1px solid #E0E0E0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textAlign: "left",
      padding: "0px 14px !important",
    };

    const headerCellStyle = {
      ...cellStyle,
      fontWeight: 600,
      backgroundColor: "#F9FAFC",
      textAlign: "left",
      paddingLeft: "16px",
    };
    return (
      <Box sx={{ overflow: "hidden" }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px", // Sets the vertical height of text
            marginTop: "16px", // Simulates `top: 16px`
            marginLeft: "25px", // Simulates `left: 25px`
            mb: 2,
            overflow: "hidden",
          }}
        >
          Schedule Information - {tableHeading}
        </Typography>

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: 400,
            boxShadow: "none",
            border: "1px solid #E0E0E0",
            overflowY: "auto",
          }}
          className="scroll"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ height: 48 }}>
                {["#", "Scan Name", "Frequency", "Schedule", "Time"].map(
                  (header) => (
                    <TableCell
                      key={header}
                      sx={{
                        ...headerCellStyle,
                      }}
                    >
                      {header}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {scheduledTableInfo &&
                scheduledTableInfo.map((row: any, index: number) => (
                  <TableRow
                    key={index}
                    sx={{
                      height: 48,
                      backgroundColor: index % 2 === 0 ? "#FAFAFF" : "#FFFFFF",
                    }}
                  >
                    <TableCell sx={{ ...cellStyle }}>{index + 1}</TableCell>
                    <TableCell sx={{ ...cellStyle }}>{row.Scan_Name}</TableCell>
                    <TableCell sx={{ ...cellStyle }}>{row.Frequency}</TableCell>
                    <TableCell sx={{ ...cellStyle }}>{row.Schedule}</TableCell>
                    <TableCell sx={{ ...cellStyle }}>{row.Time}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  // Framework columns only for frameworks switched on for the organization
  const generateNISTColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const nistKeys = Object.keys(data[0]).filter((key) =>
      key.startsWith("NIST_") && isFrameworkKeyOn(key)
    );
    return nistKeys.map((key, index) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 140,
      width: 155,
      showNist: index === 0,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue); // ✅ Round to nearest whole number

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const generateCISColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const cisKeys = Object.keys(data[0]).filter((key) =>
      key.startsWith("CIS_") && isFrameworkKeyOn(key)
    );
    return cisKeys.map((key, index) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 140,
      width: 155,
      // showNist: index === 0,
      showNist: false,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue);

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const generatePCIColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const pciKeys = Object.keys(data[0]).filter((key) => key.startsWith("PCI") && isFrameworkKeyOn(key));
    return pciKeys.map((key) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 120,
      width: 135,
      // showNist: index === 0,
      showNist: false,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue); // ✅ Round to nearest whole number

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const generateSPARKColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const sparkKeys = Object.keys(data[0]).filter((key) => key.startsWith("SPARK_") && isFrameworkKeyOn(key));
    return sparkKeys.map((key) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 120,
      width: 135,
      showNist: false,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue);

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };

  const nistColumns = generateNISTColumns(assetsRowData);
  const cisColumns = generateCISColumns(assetsRowData);
  const pciColumns = generatePCIColumns(assetsRowData);
  const sparkColumns = generateSPARKColumns(assetsRowData);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    suppressMovable: false,
    valueFormatter: (params: any) => {
      if (params.value === null || params.value === undefined || params.value === "") {
        return "-";
      }
      return params.value;
    },
  };
  const gridOptions: GridOptions = {
    defaultColDef,
    rowHeight: 48,
    headerHeight: 48,
    suppressCellFocus: true,
    rowStyle: { cursor: "pointer" },
    suppressRowClickSelection: true,
    rowMultiSelectWithClick: false,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    rowSelection: "multiple" as const,
    onSelectionChanged: (event: any) => {
      const selectedNodes = event.api.getSelectedNodes();
      const selectedData = selectedNodes.map((node: any) => node.data);
      updateSelectedRows(selectedData);
    },
  };
  // 🚀 Use useMemo to recalculate column definitions when unique values change
  const assetsColumnDefs: any = useMemo(() => {
    return [
      {
        field: "selection",
        headerName: "",
        minWidth: 50,
        width: 50,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        // pinned: "left",
        sortable: false,
        filter: false,
        resizable: false,
        suppressMovable: true,
        lockPosition: true,
        lockPinned: true,
        suppressSizeToFit: true,
      },
      {
        field: "number",
        headerName: "#",
        lockPosition: true,
        lockPinned: true,
        filter: false,
        sortable: false,
        minWidth: 60,
        width: 70,
        valueGetter: (params: any) =>
          params.node?.rowIndex === null || params.node?.rowIndex === undefined
            ? "-"
            : params.node.rowIndex + 1,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        },
      },
      {
        field: "device_name",
        headerName: environmentFilter === "cloud" ? "Resource Name" : "Name",
        filter: true,
        sortable: true,
        comparator: caseInsensitiveComparator,
        minWidth: 160,
        width: 180,
        lockPosition: true,
        lockPinned: true,
        // customFilter: CustomSetFilterComp,
        valueGetter: (params: any) => {
          const deviceName = params.data?.device_name || "";
          const criticality = params.data?.criticality || "";
          return `${deviceName} ${criticality}`;
        },
        cellRendererParams: {
          onPopoverOpen: handlePopoverOpen,
          onPopoverClose: handlePopoverClose,
        },
        cellRenderer: (params: any) => {
          const { onPopoverOpen } = params;
          const vendor = String(params.data?.vendor ?? "").toLowerCase().trim();
          const isAwsAsset = vendor === "aws" || vendor === "amazon web services";
          const handleCalendarClick = async () => {
            const response = await axiosInstance.get(
              `${END_POINTS.SCHEDULE_ASSET_POPUP}?asset_uuid=${params?.data?.id
              }&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
            );
            if (response?.status === 200) {
              setScheduledTableInfo(response?.data?.data || []);
              setIsTableParams(params?.data?.device_name);
            }
          };
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
              }}
            >
              {!isCloudAsset(params?.data) && (
                <div
                  className="ag-criticality-bar"
                  style={{
                    width: "4px",
                    height: "32px",
                    backgroundColor:
                      criticalityColors[params?.data?.criticality?.toLowerCase()] ||
                      "#B71E31",

                    borderRadius: "2px",
                    marginRight: "8px",
                    flexShrink: 0,
                  }}
                  // onMouseEnter={(e) => onPopoverOpen(e, params?.data)}
                  // onMouseLeave={onPopoverClose}
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onPopoverOpen(e, params?.data);
                  }}
                ></div>
              )}
              <Tooltip
                title={params.data.device_name}
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#fff",
                      color: "#000",
                      boxShadow: 1,
                      fontSize: "0.775rem",
                      cursor: "pointer",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#fff",
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    fontSize: "14px",
                    flexGrow: 1,
                    minWidth: 0,
                  }}
                >
                  {isAwsAsset && (
                    <img
                      src={isDarkMode ? AWS_DARK : Aws_img}
                      alt="AWS"
                      style={{ width: "20px", height: "20px", marginRight: "8px", flexShrink: 0 }}
                    />
                  )}
                  {params.data.device_name}
                  {params.data.schedule === "scheduled" &&
                    hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
                    hasPermissions(
                      ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY
                    ) && (
                      <IconButton
                        onClick={handleCalendarClick}
                        sx={{ color: "green" }}
                      >
                        <img
                          src={green_calender}
                          alt="Scheduled"
                          onClick={() => setIsCalenderIconClicked(true)}
                        />
                      </IconButton>
                    )}
                  {params.data.schedule == "schedulable" &&
                    hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
                    hasPermissions(
                      ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY
                    ) && (
                      <IconButton
                        onClick={handleCalendarClick}
                        sx={{ color: "blue" }}
                      >
                        <img src={bule_calender} alt="Schedulable" />
                      </IconButton>
                    )}
                </Box>
              </Tooltip>
            </Box>
          );
        },
      },

      {
        field: "ip_address",
        headerName: "IP Address",
        filter: true,
        sortable: true,
        minWidth: 140,
        width: 160,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => params.data?.ip_address || "-",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      ...(environmentFilter === "cloud"
        ? [{
            field: "cloud_account_id",
            headerName: "Account ID",
            filter: true,
            sortable: true,
            minWidth: 140,
            width: 160,
            valueGetter: (params: any) =>
              params.data?.cloud_account_id || params.data?.account_id || "-",
            cellStyle: {
              display: "flex",
              alignItems: "center",
            },
          }]
        : []),
      {
        field: "vendor",
        headerName: "Vendor",
        filter: VendorFilter,
        filterParams: {
          vendors: uniqueValues.vendor,
          isDarkMode: isDarkMode,
        },
        width: 135,
        minWidth: 120,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        },
        cellRenderer: (params: ICellRendererParams) => {
          const vendor = params.data.vendor?.toLowerCase();

          const getImage = () => {
            if (vendor === "cisco")
              return (
                <img src={isDarkMode ? cisco_dark : cisco_assets} alt="Cisco" />
              );
            if (vendor === "juniper")
              return (
                <img
                  src={isDarkMode ? juniper_dark : juniperLogo}
                  alt="Juniper"
                />
              );
            if (vendor === "palo alto" || vendor === "paloalto" || vendor?.includes("palo alto") || vendor?.includes("paloalto"))
              return (
                <img
                  src={isDarkMode ? paloalto_dark : paloalto_assets}
                  alt="Palo Alto"
                  style={{ height: "30px", maxWidth: "80px", objectFit: "contain" }}
                />
              );
            if (vendor === "arista")
              return (
                <img
                  src={isDarkMode ? arista_dark : arista_assets}
                  alt="Arista"
                />
              );
            if (vendor === "fortinet")
              return (
                <img
                  src={isDarkMode ? fortinet_scan_dark : fortinet_img}
                  alt="Fortinet"

                  style={{ width: "50px", height: "50px" }}
                />
              );
            if (vendor === "ubuntu")
              return (
                <img
                  src={isDarkMode ? ubuntu_dark : ubuntu_white}
                  alt="Ubuntu"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "microsoft")
              return (
                <img
                  src={isDarkMode ? windows_dark : windows_light}
                  alt="microsoft"
                  style={
                    isDarkMode
                      ? { width: "100px", height: "55px", objectFit: "contain", objectPosition: "left", marginLeft: "-14px" }
                      : { width: "70px", height: "40px" }
                  }
                />
              );
            if (vendor === "redhat")
              return (
                <img
                  src={isDarkMode ? redhat_dark : redhat_light}
                  alt="microsoft"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "debian")
              return (
                <img
                  src={isDarkMode ? debian_dark : debian}
                  alt="Debian"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "huawei")
              return (
                <img
                  src={isDarkMode ? huawei_dark : huawei_light}
                  alt="Huawei"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "mikrotik")
              return (
                <img
                  src={isDarkMode ? mikrotik_dark : mikrotik}
                  alt="Mikrotik"
                  style={{ width: "90px", height: "35px", objectFit: "contain" }}
                />
              );
            if (vendor === "edgecore")
              return (
                <img
                  src={edgecore_logo}
                  alt="Edgecore"
                  style={{ width: "80px", height: "30px", objectFit: "contain", filter: isDarkMode ? "brightness(0) invert(1)" : "none" }}
                />
              );
            if (vendor === "tp-link" || vendor === "tplink")
              return (
                <img
                  src={isDarkMode ? tplink_dark : tplink_light}
                  alt="TP-Link"
                  style={{ width: "80px", height: "30px", objectFit: "contain" }}
                />
              );
            if (vendor === "dell")
              return (
                <img
                  src={dell_logo}
                  alt="Dell"
                  style={{ width: "40px", height: "40px", objectFit: "contain" }}
                />
              );
            if (vendor === "syrotech")
              return (
                <img
                  src={isDarkMode ? syrotech_dark : syrotech_light}
                  alt="Syrotech"
                  style={{ width: "90px", height: "32px", objectFit: "contain" }}
                />
              );
            if (vendor === "apple")
              return (
                <img
                  src={isDarkMode ? apple_dark : apple_img}
                  alt="Apple"
                  style={{ width: "40px", height: "40px", objectFit: "contain" }}
                />
              );
            if (
              vendor === "aws" ||
              vendor === "amazon web services" ||
              vendor?.includes("amazon") ||
              vendor?.includes("aws")
            )
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 56,
                    height: 32,
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                    bgcolor: isDarkMode ? "rgba(255,255,255,0.04)" : "#FFFFFF",
                    px: 0.75,
                  }}
                >
                  <img
                    src={isDarkMode ? AWS_DARK : Aws_img}
                    alt="AWS"
                    style={{ width: 40, height: 22, objectFit: "contain" }}
                  />
                </Box>
              );
            return null;
          };

          const image = getImage();

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {image || (
                <Typography
                  title={params.data.vendor}
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {params.data.vendor || "-"}
                </Typography>
              )}
            </div>
          );
        },
      },
      {
        field: "model",
        headerName: "OS",
        filter: ModelFilter,
        filterParams: {
          models: uniqueValues.model,
          isDarkMode: isDarkMode,
        },
        sortable: true,
        minWidth: 95,
        width: 110,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => params.data?.model || "-",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "os_version",
        headerName: "OS Version",
        filter: true,
        sortable: true,
        minWidth: 140,
        width: 160,
        hide: true,
        valueGetter: (params: any) => params.data?.os_version || "-",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "device_type",
        headerName: environmentFilter === "cloud" ? "Resource Type" : "Type",
        filter: DeviceTypeFilter,
        filterParams: {
          deviceTypes: uniqueValues.device_type,
          isDarkMode: isDarkMode,
        },
        sortable: true,
        minWidth: environmentFilter === "cloud" ? 150 : 105,
        width: environmentFilter === "cloud" ? 170 : 120,
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },

      {
        field: "security_score",
        headerName: "Score",
        filter: true,
        minWidth: 125,
        width: 135,
        valueGetter: (params: any) => {
          const score = params.data?.security_score;
          const count = params.data?.failed_count;
          if (
            params.data?.status === 3 &&
            isZeroOrEmpty(score) &&
            isZeroOrEmpty(count)
          ) {
            return "-";
          }
          return params.data?.security_score;
        },
        cellRenderer: (params: ICellRendererParams) => {
          if (params.data?.status !== 3) {
            return (
              <Box display="flex" alignItems="center" gap={1}>
                <LoopIcon sx={{ color: "text.secondary", fontSize: 16 }} />
                <span>Scanning...</span>
              </Box>
            );
          }
          const score = params.data?.security_score;
          const count = params.data?.failed_count;
          if (isZeroOrEmpty(score) && isZeroOrEmpty(count)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          return (
            <Tooltip
              title={params.data.security_score}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                {params.data.security_score <= 50 && (
                  <img src={red_shield} alt="Low Security Score" />
                )}
                {params.data.security_score > 50 &&
                  params.data.security_score < 80 && (
                    <img src={orange_shield} alt="Medium Security Score" />
                  )}
                {params.data.security_score >= 80 && (
                  <img src={green_shield} alt="High Security Score" />
                )}
                {/* <Typography>{Math.round(params.data.security_score)}</Typography> */}
                <Typography>
                  {!isNaN(Number(params.data.security_score))
                    ? Math.round(params.data.security_score)
                    : "0"}
                </Typography>
              </Box>
            </Tooltip>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "vulnerability",
        headerName: "Misconfig",
        filter: "agNumberColumnFilter", // ensures numeric filter
        minWidth: 135,
        width: 145,
        valueGetter: (params: any) => {
          const score = params.data?.security_score;
          const count = params.data?.failed_count;
          if (isZeroOrEmpty(score) && isZeroOrEmpty(count)) return "-";
          // Make sure AG Grid sees this number for filtering and sorting
          return params.data?.status === 3 ? params.data?.failed_count ?? 0 : 0;
        },
        cellRenderer: (params: ICellRendererParams) => {
          const score = params.data?.security_score;
          const count = params.data?.failed_count;
          if (isZeroOrEmpty(score) && isZeroOrEmpty(count)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          return params.data?.status === 3 ? (
            <Tooltip
              title={String(params.data?.failed_count)}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                {params.data?.failed_count >= 0 && (
                  <img
                    src={misconfig}
                    alt="Misconfigurations"
                    style={{ width: 20, height: 20 }}
                  />
                )}
                <Typography>{params.data?.failed_count}</Typography>
              </Box>
            </Tooltip>
          ) : (
            <>0</>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "cve_score",
        headerName: "CVE Score",
        filter: true,
        minWidth: 125,
        width: 135,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const score = params.data?.cve_score;
          if (isDiscovery && isZeroOrEmpty(score)) return "-";
          return params.data?.cve_score;
        },
        cellRenderer: (params: ICellRendererParams) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const score = params.data?.cve_score;
          if (isDiscovery && isZeroOrEmpty(score)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          return params.data?.status === 3 ? (
            <Tooltip
              title={
                !isNaN(Number(params.data?.cve_score))
                  ? Math.round(Number(params.data?.cve_score))
                  : "0"
              }
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                {params.data.cve_score <= 50 && (
                  <img src={red_bug} alt="Low Cve Score" />
                )}
                {params.data.cve_score > 50 && params.data.cve_score < 80 && (
                  <img
                    src={cveBug}
                    alt="Medium Cve Score"
                    style={{ width: 20, height: 20 }}
                  />
                )}
                {params.data.cve_score >= 80 && (
                  <img src={green_bug} alt="High Cve Score" />
                )}

                <Typography>
                  {!isNaN(Number(params.data?.cve_score))
                    ? Math.round(params.data?.cve_score)
                    : "0"}
                </Typography>
              </Box>
            </Tooltip>
          ) : (
            ""
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "cve",
        headerName: "CVE's",
        filter: true,
        minWidth: 110,
        width: 125,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const cveVal = params.data?.cve;
          if (isDiscovery && isZeroOrEmpty(cveVal)) return "-";
          return params.data?.cve;
        },
        cellRenderer: (params: ICellRendererParams) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const cveVal = params.data?.cve;
          if (isDiscovery && isZeroOrEmpty(cveVal)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          return params.data?.status === 3 ? (
            <Tooltip
              title={params.data?.cve}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <img
                  src={cveBugError}
                  alt="Cve"
                  style={{ width: 20, height: 20 }}
                />
                <Typography>{Math.round(params.data?.cve)}</Typography>
              </Box>
            </Tooltip>
          ) : (
            ""
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
            {
        field: "windows_software_count",
        headerName: "Software",
        filter: true,
        sortable: true,
        minWidth: 125,
        width: 140,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const count = params.data?.windows_software_count ?? params.data?.software_count;
          if (isDiscovery && isZeroOrEmpty(count)) return "-";
          return count !== undefined && count !== null ? count : "-";
        },
        cellRenderer: (params: ICellRendererParams) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const count = params.data?.windows_software_count ?? params.data?.software_count;
          if (isDiscovery && isZeroOrEmpty(count)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          return (
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {count !== undefined && count !== null ? count : "-"}
            </Typography>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "open_ports",
        headerName: "Open Ports",
        filter: true,
        sortable: true,
        minWidth: 135,
        width: 150,
        hide: environmentFilter === "cloud",
        valueGetter: (params: any) => {
          const ports = params.data?.discovery_ports;
          return Array.isArray(ports) ? ports.length : 0;
        },
        cellRenderer: (params: ICellRendererParams) => {
          const ports = params.data?.discovery_ports;
          const count = Array.isArray(ports) ? ports.length : 0;
          return (
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {count}
            </Typography>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "last_scan",
        headerName: environmentFilter === "cloud" ? "Last Scanned" : "Last Scan",
        filter: true,
        minWidth: 195,
        width: 215,
        cellRenderer: (params: ICellRendererParams) => {
          if (!params.value) return "";
          if (params.data?.status !== 3) {
            return null;
          }
          const date = moment(params.value);
          return (
            <Tooltip
              title={date.format("DD-MMMM-YYYY HH:mm:ss")}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {params.data?.type?.toLowerCase() === "discovery"
                    ? params.data?.discovery_total ?? params.data?.total
                    : params.data?.total}
                </Box>
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {date.format("DD-MMM-YYYY HH:mm:ss")}
                </Typography>
              </Box>
            </Tooltip>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      //  {
      //    field: "last_updated",
      //    headerName: "Last Updated",
      //    filter: true,
      //    minWidth: 160,
      //    cellRenderer: (params: ICellRendererParams) => {
      //      if (!params.value) return "";
      //      const date = moment(params.value);
      //      return (
      //        <Box display="flex" alignItems="center">
      //          <Typography
      //            title={date.format("YYYY-MM-DD HH:mm:ss")}
      //            sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
      //          >
      //            {date.fromNow()}
      //          </Typography>
      //        </Box>
      //      );
      //    }
      //  },
      {
        field: "region_name",
        headerName: environmentFilter === "cloud" ? "Region" : "Regions",
        filter: true,
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
        // showNist: false,
        minWidth: 120,
        width: 135,
        cellRenderer: (params: ICellRendererParams) => {
          return (
            <Tooltip
              title={params.data?.region_name}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                    cursor: "pointer",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {params.data?.region_name?.length > 25
                    ? params.data.region_name.slice(0, 25) + "..."
                    : params.data?.region_name}
                </Typography>
              </Box>
            </Tooltip>
          );
        },
      },

      ...nistColumns,
      ...cisColumns,
      ...pciColumns,
      ...sparkColumns,
      {
        field: "actions",
        headerName: "Actions",
        width: 80,
        minWidth: 80,
        filter: false,
        sortable: false,
        hide: false,
        cellRenderer: (params: ICellRendererParams) => {
          if (params.data?.status !== 3) {
            return null;
          }

          const isCloud = isCloudAsset(params.data);

          const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
          const open = Boolean(anchorEl);

          const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          };

          const handleShowConfig = (deviceId: any, selectDevice: any = null) => {
            dispatch(
              setConfigDiffData({
                rowData: selectDevice,
                device_id: String(deviceId),

                click: "assets",
              })

            );
            navigate(`/on-premises/configdiff`, {
              state: { device_id: String(deviceId) }
            });
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          const handleAction = (
            action: string,
            deviceId?: string,
            selectDevice?: any
          ) => {
            switch (action) {
              case "rescanWithCredential":
                if (deviceId) {
                  setDeviceIds([deviceId]);
                }
                handleRescanWithCredential();
                break;
              case "rescan":
                handleRescan(deviceId, selectDevice);
                break;
              case "showConfig":
                handleShowConfig(deviceId, selectDevice);
                break;
              case "map":
                if (deviceId) {
                  setDeviceIds([deviceId]);
                }
                handleMap();
                break;
              case "mapTemplate":
                handleMapTemplate(selectDevice);
                break;
              case "decommission":
                if (deviceId) {
                  setDeviceIds([deviceId]);
                }
                setIsDecommissionDialogOpen(true);
                break;
              case "CancelSchedule":
                if (deviceId) {
                  setDeviceIds([deviceId]);
                }
                setRemoveAllSchedules(false);
                setIsCancelSchedulePopupOpen(true);
                break;
              case "scheduleScan":
                if (deviceId) {
                  setDeviceIds([deviceId]);
                }
                if (selectDevice) {
                  setIsAllScheduleable(
                    selectDevice.schedule === "schedulable" ? true : false
                  );
                }
                handleScheduleScan();
                break;
            }
            handleClose();
          };

          const isDiscoveryAsset =
            params.data?.type?.toLowerCase() === "discovery" ||
            params.data?.scan_type?.toLowerCase() === "discovery";

          // Check if there are any menu items to show
          const hasMenuItems = () => {
            if (isCloud) {
              return hasPermissions(ROLES_CONTENT_PROPS.DECOMMISSION_DEVICE);
            }
            const isExcludedFromDecommission = isDecommissionExcludedVendor(params.data.vendor);

            // Check decommission permission (hidden for certain vendors like Linux and Windows/WinRM, and for discovery assets)
            const showDecommission = !isDiscoveryAsset && hasPermissions(ROLES_CONTENT_PROPS.DECOMMISSION_DEVICE) && !isExcludedFromDecommission;

            // Check show config diff (not for endpoints and not for discovery)
            const showConfigDiff =
              params.data.device_type?.toLowerCase() !== "endpoint" &&
              params.data.type?.toLowerCase() !== "discovery";

            // Check schedule permissions
            const showCancelSchedule = hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
              hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
              params.data.schedule === "scheduled";

            const showScheduleScan = hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
              hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
              (params.data.schedule === "scheduled" || params.data.schedule === "schedulable");

            // Check rescan permissions
            const showRescanWithCredential = !isDiscoveryAsset && hasPermissions(ROLES_CONTENT_PROPS.CREDENTIAL_MANAGER) && params.data.rescan;
            const showRescan = hasPermissions(ROLES_CONTENT_PROPS.RESCAN_DEVICE) && (isDiscoveryAsset || (params.data.rescan && params.data.status === 3));
            const showMapCredential = !isDiscoveryAsset && hasPermissions(ROLES_CONTENT_PROPS.CREDENTIAL_MANAGER) && params.data.rescan;
            const showMapTemplate = canMapTemplateToAsset(params.data);

            return showDecommission || showConfigDiff || showCancelSchedule || showScheduleScan ||
              showRescanWithCredential || showRescan || showMapCredential || showMapTemplate;
          };

          const menuItemsAvailable = hasMenuItems();
          const isButtonDisabled = !menuItemsAvailable;

          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton
                size="small"
                disabled={isButtonDisabled}
                onClick={isButtonDisabled ? undefined : handleClick}
                sx={{
                  color: isButtonDisabled ? "action.disabled" : "text.secondary",
                  cursor: isButtonDisabled ? "not-allowed" : "pointer",
                  opacity: isButtonDisabled ? 0.38 : 1,
                  "&:hover": {
                    backgroundColor: isButtonDisabled ? "transparent" : "action.hover",
                  },
                }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
              {menuItemsAvailable && (
                <Menu
                  anchorEl={anchorEl}
                  open={open && menuItemsAvailable}
                  onClose={handleClose}
                  onClick={(e) => e.stopPropagation()}
                  PaperProps={{
                    sx: {
                      width: "auto",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                      fontSize: 13,
                      py: 0.5,
                      minHeight: 32,
                    },
                  }}
                >
                  {!isDiscoveryAsset &&
                    !isCloud &&
                    !isDecommissionExcludedVendor(params.data.vendor) && (
                      <MenuItem
                        onClick={() => handleAction("decommission", params.data.id)}
                        sx={{
                          fontSize: 13,
                          py: 0.5,
                          minHeight: 32,
                        }}
                      >
                        Decommission
                      </MenuItem>
                    )}
                  {params.data.device_type?.toLowerCase() !== "endpoint" &&
                    params.data.type?.toLowerCase() !== "discovery" && (
                      <MenuItem
                        onClick={() =>
                          handleAction("showConfig", params.data.id, params.data)
                        }
                        sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                      >
                        Show Config Diff
                      </MenuItem>
                    )}
                  {hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
                    hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
                    params.data.schedule === "scheduled" && (
                      <MenuItem
                        onClick={() =>
                          handleAction(
                            "CancelSchedule",
                            params.data.id,
                            params.data
                          )
                        }
                        sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                      >
                        Cancel Schedule
                      </MenuItem>
                    )}
                  {hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
                    hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
                    (params.data.schedule === "scheduled" ||
                      params.data.schedule === "schedulable") && (
                      <MenuItem
                        onClick={() =>
                          handleAction("scheduleScan", params.data.id, params.data)
                        }
                        sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                      >
                        Schedule Scan
                      </MenuItem>
                    )}

                  {/* Re-scan with different credential hidden as requested */}
                  {hasPermissions(ROLES_CONTENT_PROPS.RESCAN_DEVICE) &&
                    (params.data.type?.toLowerCase() === "discovery" ||
                      (params.data.rescan && params.data.status === 3)) && (
                      <MenuItem
                        onClick={() => handleAction("rescan", params.data.id, params.data)}
                        sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                      >
                        Rescan
                      </MenuItem>
                    )}
                  {hasPermissions(ROLES_CONTENT_PROPS.CREDENTIAL_MANAGER) &&
                    params.data.type?.toLowerCase() !== "discovery" &&
                    params.data.rescan && (
                      <MenuItem
                        onClick={() => handleAction("map", params.data.id, params.data)}
                        sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                      >
                        Map credential
                      </MenuItem>
                    )}
                  {canMapTemplateToAsset(params.data) && (
                    <MenuItem
                      onClick={() =>
                        handleAction("mapTemplate", params.data.id, params.data)
                      }
                      sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                    >
                      Map Config Template
                    </MenuItem>
                  )}
                </Menu>
              )}
            </Box>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
        cellRendererParams: {
          suppressRowClickPropagation: true,
        },
      },
    ];
  }, [uniqueValues, isDarkMode, environmentFilter]);

  const decommissionColumnDefs: ColDef[] = useMemo(() => {
    return [
      {
        field: "selection",
        headerName: "",
        minWidth: 50,
        width: 50,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        // pinned: "left",
        sortable: false,
        filter: false,
        resizable: false,
        suppressMovable: true,
        lockPosition: true,
        lockPinned: true,
        // cellClass: "checkbox-cell",
        // headerClass: "checkbox-header",
        suppressSizeToFit: true,
      },
      {
        field: "number",
        headerName: "#",
        lockPosition: true,
        lockPinned: true,
        filter: false,
        sortable: false,
        minWidth: 60,
        width: 70,
        valueGetter: (params: any) =>
          params.node?.rowIndex === null || params.node?.rowIndex === undefined
            ? "-"
            : params.node.rowIndex + 1,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        },
      },
      {
        field: "device_name",
        headerName: "Name",
        sortable: true,
        filter: true,
        comparator: caseInsensitiveComparator,
        minWidth: 160,
        width: 180,
        cellRenderer: (params: ICellRendererParams) => {
          const criticalityColors: any = {
            critical: "firebrick",
            high: "orange",
            low: "limegreen",
            default: "#B71E31",
          };

          const vendor = String(params.data?.vendor ?? "").toLowerCase().trim();
          const isAwsAsset = vendor === "aws" || vendor === "amazon web services";

          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
              }}
            >
              {!isCloudAsset(params?.data) && (
                <div
                  className="ag-criticality-bar"
                  style={{
                    width: "4px",
                    height: "32px",
                    backgroundColor:
                      criticalityColors[params?.data?.criticality?.toLowerCase()] ||
                      "#B71E31",
                    borderRadius: "2px",
                    marginRight: "8px",
                    flexShrink: 0,
                    cursor: "pointer",
                  }}
                ></div>
              )}
              {isAwsAsset && (
                <img
                  src={isDarkMode ? AWS_DARK : Aws_img}
                  alt="AWS"
                  style={{ width: "20px", height: "20px", marginRight: "8px", flexShrink: 0 }}
                />
              )}
              <Typography
                title={params.data?.device_name}
                sx={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  flexGrow: 1,
                  minWidth: 0,
                  cursor: "pointer",
                }}
              >
                {params.data?.device_name}
              </Typography>
            </Box>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "vendor",
        headerName: "Vendor",
        filter: VendorFilter,
        filterParams: {
          vendors: uniqueValues.vendor,
          isDarkMode: isDarkMode,
        },
        width: 135,
        minWidth: 120,
        cellRenderer: (params: ICellRendererParams) => {
          const vendor = params.data?.vendor?.toLowerCase();

          const getImage = () => {
            if (vendor === "cisco")
              return (
                <img src={isDarkMode ? cisco_dark : cisco_assets} alt="Cisco" />
              );
            if (vendor === "juniper")
              return (
                <img
                  src={isDarkMode ? juniper_dark : juniperLogo}
                  alt="Juniper"
                />
              );
            if (vendor === "palo alto" || vendor === "paloalto" || vendor?.includes("palo alto") || vendor?.includes("paloalto"))
              return (
                <img
                  src={isDarkMode ? paloalto_dark : paloalto_assets}
                  alt="Palo Alto"
                  style={{ height: "30px", maxWidth: "80px", objectFit: "contain" }}
                />
              );
            if (vendor === "arista")
              return (
                <img
                  src={isDarkMode ? arista_dark : arista_assets}
                  alt="Arista"
                />
              );
            if (vendor === "fortinet")
              return (
                <img
                  src={isDarkMode ? fortinet_scan_dark : fortinet_img}
                  alt="Fortinet"
                  style={{ width: "50px", height: "50px" }}
                />
              );
            if (vendor === "ubuntu")
              return (
                <img
                  src={isDarkMode ? ubuntu_dark : ubuntu_white}
                  alt="Ubuntu"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "microsoft")
              return (
                <img
                  src={isDarkMode ? windows_dark : windows_light}
                  alt="microsoft"
                  style={
                    isDarkMode
                      ? { width: "100px", height: "55px", objectFit: "contain", objectPosition: "left", marginLeft: "-14px" }
                      : { width: "70px", height: "40px" }
                  }
                />
              );
            if (vendor === "redhat")
              return (
                <img
                  src={isDarkMode ? redhat_dark : redhat_light}
                  alt="microsoft"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "debian")
              return (
                <img
                  src={isDarkMode ? debian_dark : debian}
                  alt="Debian"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "huawei")
              return (
                <img
                  src={isDarkMode ? huawei_dark : huawei_light}
                  alt="Huawei"
                  style={{ width: "70px", height: "40px" }}
                />
              );
            if (vendor === "mikrotik")
              return (
                <img
                  src={isDarkMode ? mikrotik_dark : mikrotik}
                  alt="Mikrotik"
                  style={{ width: "90px", height: "35px", objectFit: "contain" }}
                />
              );
            if (vendor === "edgecore")
              return (
                <img
                  src={edgecore_logo}
                  alt="Edgecore"
                  style={{ width: "80px", height: "30px", objectFit: "contain", filter: isDarkMode ? "brightness(0) invert(1)" : "none" }}
                />
              );
            if (vendor === "tp-link" || vendor === "tplink")
              return (
                <img
                  src={isDarkMode ? tplink_dark : tplink_light}
                  alt="TP-Link"
                  style={{ width: "80px", height: "30px", objectFit: "contain" }}
                />
              );
            if (vendor === "dell")
              return (
                <img
                  src={dell_logo}
                  alt="Dell"
                  style={{ width: "40px", height: "40px", objectFit: "contain" }}
                />
              );
            if (vendor === "syrotech")
              return (
                <img
                  src={isDarkMode ? syrotech_dark : syrotech_light}
                  alt="Syrotech"
                  style={{ width: "70px", height: "28px", objectFit: "contain" }}
                />
              );
            if (vendor === "apple" || vendor === "macos")
              return (
                <img
                  src={isDarkMode ? apple_dark : apple_img}
                  alt="Apple"
                  style={{ width: "28px", height: "28px", objectFit: "contain" }}
                />
              );
            if (
              vendor === "aws" ||
              vendor === "amazon web services" ||
              vendor?.includes("amazon") ||
              vendor?.includes("aws")
            )
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 56,
                    height: 32,
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                    bgcolor: isDarkMode ? "rgba(255,255,255,0.04)" : "#FFFFFF",
                    px: 0.75,
                  }}
                >
                  <img
                    src={isDarkMode ? AWS_DARK : Aws_img}
                    alt="AWS"
                    style={{ width: 40, height: 22, objectFit: "contain" }}
                  />
                </Box>
              );
            return null;
          };

          const image = getImage();

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {image || (
                <Typography
                  title={params.data?.vendor}
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {params.data?.vendor || "-"}
                </Typography>
              )}
            </div>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        },
      },
      { field: "model", headerName: "OS", filter: ModelFilter, filterParams: { models: uniqueValues.model, isDarkMode: isDarkMode }, minWidth: 95, width: 110 },
      {
        field: "device_type",
        headerName: "Type",
        filter: DeviceTypeFilter,
        filterParams: {
          deviceTypes: uniqueValues.device_type,
          isDarkMode: isDarkMode,
        },
        minWidth: 105,
        width: 120,
      },
      {
        field: "windows_software_count",
        headerName: "Software",
        filter: true,
        sortable: true,
        minWidth: 125,
        width: 140,
        valueGetter: (params: any) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const count = params.data?.windows_software_count ?? params.data?.software_count;
          if (isDiscovery && isZeroOrEmpty(count)) return "-";
          return count !== undefined && count !== null ? count : "-";
        },
        cellRenderer: (params: ICellRendererParams) => {
          const isDiscovery = params.data?.type?.toLowerCase() === "discovery";
          const count = params.data?.windows_software_count ?? params.data?.software_count;
          if (isDiscovery && isZeroOrEmpty(count)) {
            return (
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                -
              </Typography>
            );
          }
          const countVal = params.data?.windows_software_count ?? params.data?.software_count;
          return (
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {countVal !== undefined && countVal !== null ? countVal : "-"}
            </Typography>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "open_ports",
        headerName: "Open Ports",
        filter: true,
        sortable: true,
        minWidth: 135,
        width: 150,
        valueGetter: (params: any) => {
          const ports = params.data?.discovery_ports;
          return Array.isArray(ports) ? ports.length : 0;
        },
        cellRenderer: (params: ICellRendererParams) => {
          const ports = params.data?.discovery_ports;
          const count = Array.isArray(ports) ? ports.length : 0;
          return (
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {count}
            </Typography>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      //  { field: "region_name", headerName: "Region", filter: true, minWidth: 150 },
      //  { field: "last_scan_date", headerName: "Total & LastScan", filter: true, minWidth: 150 },
      {
        field: "decommission_on",
        headerName: "Decommissioned On",
        filter: true,
        minWidth: 175,
        width: 190,
        cellRenderer: (params: ICellRendererParams) => {
          if (!params.value) return "";
          const date = moment(params.value);
          return date.format("Do MMMM, YYYY");
        },
      },
      {
        field: "security_score",
        headerName: "Status",
        filter: true,
        minWidth: 150,
        width: 170,
        cellRenderer: () => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "#F4F5FA",
              border: "1px solid #8B93A6",
              borderRadius: "4px",
              padding: "2px 16px 2px 4px",
              width: "fit-content",
              height: 18,
              fontWeight: 600,
              fontSize: "12px",
              color: "#5B6172",
              gap: "8px",
            }}
          >
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#6B7280",
                display: "inline-block",
                marginRight: "8px",
              }}
            />
            Decommissioned
          </div>
        ),
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
      },
      {
        field: "decommission_by",
        headerName: "Decommissioned by",
        filter: true,
        minWidth: 175,
        width: 190,
        // cellRenderer: (params: ICellRendererParams) => {
        //   if (!params?.data?.decommission_by) return "";
        //   return (
        //       <Typography
        //         title={params.value}
        //         sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
        //       >
        //         {params?.data?.decommission_by}
        //       </Typography>

        //   );
        // },
      },
      //  { field: "vulnerability", headerName: "Misconfigurations", filter: true, minWidth: 150 },
      //  { field : "cve", headerName: "CVEs", filter: true, minWidth: 150 },
      {
        field: "actions",
        headerName: "",
        width: 50,
        filter: false,
        sortable: false,
        cellRenderer: (params: ICellRendererParams) => {
          const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
          const open = Boolean(anchorEl);

          const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          const handleAction = (action: string) => {
            switch (action) {
              case "Commission":
                setDeviceIds([params.data.id]);
                setCommissionRowData(params.data);
                setIsCommissionDialogOpen(true);
                break;
            }
            handleClose();
          };

          const isExcluded = isDecommissionExcludedVendor(params.data?.vendor);
          const isCloud = isCloudAsset(params.data);
          if (params.data?.type === "discovery") return null;

          const isRowDisabled = isExcluded;

          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton
                size="small"
                disabled={isRowDisabled}
                onClick={isRowDisabled ? undefined : handleClick}
                sx={{
                  color: isRowDisabled ? "action.disabled" : "text.secondary",
                  cursor: isRowDisabled ? "not-allowed" : "pointer",
                  opacity: isRowDisabled ? 0.38 : 1,
                  "&:hover": {
                    backgroundColor: isRowDisabled ? "transparent" : "action.hover",
                  },
                }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
              {!isRowDisabled && (
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  onClick={(e) => e.stopPropagation()}
                  PaperProps={{
                    sx: {
                      width: 200,
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <MenuItem onClick={() => handleAction("Commission")}>
                    Commission
                  </MenuItem>
                </Menu>
              )}
            </Box>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
        cellRendererParams: {
          suppressRowClickPropagation: true,
        },
      },
    ];
  }, [uniqueValues, isDarkMode]); // 🚀 Simplified dependencies for decommissionColumnDefs

  // const handleScanRowClick = (rowData: any) => {
  //   setDeviceIds(rowData.id);
  //   setSelectedAssetSideNav(rowData);
  //   setAssetDrawerOpen(true);
  // };
  const handleScanRowClick = (rowData: any) => {
    const isLastScanStatusFalse =
      rowData?.last_scan_status === false ||
      String(rowData?.last_scan_status).toLowerCase() === "false";
    if (showPreviousResources && environmentFilter === "cloud" && isLastScanStatusFalse) {
      return;
    }
    setDeviceIds(rowData.id);
    setSelectedAssetSideNav(rowData);
    setAssetDrawerOpen(true);

    // Always show the kebab menu since actions like Decommission, Delete, Change Location, Asset Criticality apply to all device types
    setShowMenu(true);
  };

  const handleRescan = async (device: any, rowData?: any) => {
    let assetObj = typeof device === "object" ? device : rowData;
    if (!assetObj && (typeof device === "string" || typeof device === "number")) {
      assetObj = onPremisesDeviceData?.find(
        (d: any) => String(d.id) === String(device)
      );
    }

    if (hasActiveAgent !== true) {
      toast.error("Agent is not active. Please ensure the agent is active before rescanning.");
      return;
    }

    // Open DiscoveryRescanPopup for all assets (discovery and non-discovery)
    setDiscoveryRescanRowData(assetObj || device);
    setIsDiscoveryRescanOpen(true);

    /*
    const isDiscovery = assetObj?.type?.toLowerCase() === "discovery";

    if (isDiscovery) {
      setDiscoveryRescanRowData(assetObj || device);
      setIsDiscoveryRescanOpen(true);
      return;
    }

    try {
      const payload = {
        asset_id: [typeof device === "object" ? device.id : device],
        scan_source: "Assets",
      };
      const response = await axiosInstance.post(END_POINTS.RESCAN, payload);
      if (response.status === 200) {
        updateDeviceInfo(response?.data?.data?.device_list);
        setRescanResponseData(response?.data);
        startTimer();
      }
    } catch (error: any) {
      toast.error(
        error.response?.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    */
  };

  const handleRescanWithCredential = async () => {
    setAnchorElAction(null);
    setIsRescanPopupOpen(true);
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response?.status === 200) {
        setAssetsCredData(response?.data?.data?.cred_list);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
      if (response?.status === 200) {
        setCredtypes(response?.data?.data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleMapTemplate = (deviceOrDevices?: any) => {
    setAnchorElAction(null);
    const list = Array.isArray(deviceOrDevices)
      ? deviceOrDevices
      : deviceOrDevices
        ? [deviceOrDevices]
        : [];
    const eligible = list.filter((d: any) => canMapTemplateToAsset(d));
    if (eligible.length === 0) {
      toast.error("Config templates are only available for network devices");
      return;
    }
    if (eligible.length < list.length) {
      toast.info(
        `${list.length - eligible.length} asset${
          list.length - eligible.length > 1 ? "s were" : " was"
        } skipped (not eligible for config templates)`
      );
    }
    setMapTemplateDevices(eligible);
    setIsMapTemplateDialogOpen(true);
  };

  const handleMapTemplateDialogClose = () => {
    setIsMapTemplateDialogOpen(false);
    setMapTemplateDevices([]);
  };

  const handleMap = async () => {
    setAnchorElAction(null);
    setIsMapCredentialPopupOpen(true);
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response?.status === 200) {
        setAssetsCredData(response?.data?.data?.cred_list);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
      if (response?.status === 200) {
        setCredtypes(response?.data?.data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleRescanPopupClose = () => {
    setIsRescanPopupOpen(false);
  };
  const handleMapPopuplose = () => {
    setIsMapCredentialPopupOpen(false);
  };
  const toggleDrawer = (newOpen: boolean) => {
    setOpenSideNav(newOpen);
  };

  const handleCommissionDialogClose = () => {
    setIsCommissionDialogOpen(false);
    formikCommission.resetForm();
  };

  const handleMultipleCommission = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    // Set commission row data to the first selected row for scan date display
    if (selectedRows.length > 0) {
      setCommissionRowData(selectedRows[0]);
    }
    setIsCommissionDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleMultipleDecommission = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsDecommissionDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleDecommissionDialogClose = () => {
    setIsDecommissionDialogOpen(false);
    formikDecommission.resetForm();
  };

  const handleDeleteDialogOpen = () => {
    setIsDeleteDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleAssetCriticality = async () => {
    try {
      const payload = {
        device_id: deviceIds,
        criticality: selectedCriticalId,
      };
      const response = await axiosInstance.post(
        END_POINTS.ASSETS_CRITICALITY_UPDATE,
        payload
      );
      if (response?.status === 200) {
        setAssetCriticalityData(response?.data?.data?.criticality);
        setIsAssetCriticalityDialogOpen(false);
        setSelectAssetsCriticaledId("");
        setDeviceIds([]);
        fetchAssetsData();
        updateSelectedRows([]);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const singleHandleAssetCriticality = async (
    row: any,
    selectedCriticality: any
  ) => {
    try {
      const payload = {
        device_id: [row.id],
        criticality: selectedCriticality,
      };
      const response = await axiosInstance.post(
        END_POINTS.ASSETS_CRITICALITY_UPDATE,
        payload
      );
      if (response?.status === 200) {
        fetchAssetsData();
        updateSelectedRows([]);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const getAssetCriticality = async () => {
    try {
      const response = await axiosInstance.get(END_POINTS.ASSETS_CRITICALITY);
      if (response?.status === 200) {
        setAssetCriticalityOptions(response?.data?.data?.dropdown);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const fetchCloudAgentStatus = async () => {
    try {
      const response = await axiosInstance.get(END_POINTS.CLOUD_AGENT);
      const rawList = response?.data?.data || response?.data || [];
      const agents = Array.isArray(rawList) ? rawList : rawList?.agent_list || [];
      setCloudAgents(agents);
      setHasActiveAgent(
        agents.some(
          (agent: any) =>
            String(agent?.status_display || "").trim().toLowerCase() === "active"
        )
      );
    } catch (error) {
      setCloudAgents([]);
      setHasActiveAgent(false);
    }
  };

  const handleAssetCriticalityDialogOpen = () => {
    getAssetCriticality();
    setDeviceIds(selectedRows.map((device) => device.id));
    setIsAssetCriticalityDialogOpen(true);
    setAnchorElAction(null);
  };

  const handleAssetCriticalityDialogClose = () => {
    setSelectAssetsCriticaledId("");
    setIsAssetCriticalityDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setIsDeleteDialogOpen(false);
    formikDelete.resetForm();
  };

  const assetCount = async () => {
    dispatch(resetUserTypeFlags());

    const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
    let parsed = null;
    if (res.status === 200) {
      parsed = res?.data?.data || false;
      if (parsed.device_count == 0 && parsed.cloud_count == 0) {
        dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
        //dispatch(setIsOnlyCloudUser({ is: true }));
      } else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
        dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
      } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
        dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
      } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
        dispatch(
          setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true })
        );
      }
    }
  };

  const getSafeNumber = (value: any, fallback = 0) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : fallback;
  };

  const cancelAssetListRequest = () => {
    if (assetListRequestRef.current) {
      assetListRequestRef.current.abort();
      assetListRequestRef.current = null;
    }
  };

  const fetchAssetsData = async () => {
    console.log("fetchAssetsData called. Current location.state is:", location.state);
    cancelAssetListRequest();
    const controller = new AbortController();
    assetListRequestRef.current = controller;
    setIsLoading(true);
    try {
      const roleReq: any = {
        type: 1,
      };
      if (location.state && (location.state as any).id) {
        roleReq.id = (location.state as any).id;
       
      }
      const response = await axiosInstance.post(url, roleReq, {
        signal: controller.signal,
      });
      if (controller.signal.aborted) {
        return;
      }
      if (response.status === 200) {
        const result = response.data?.data?.device_list || [];
        dataMassage(result);

        // 🚀 Extract unique values for custom filters
        const deviceTypes = Array.from(
          new Set(
            result
              .map((asset: any) => asset.device_type)
              .filter((type: string) => type && type.trim() !== "")
          )
        ) as string[];

        const vendors = Array.from(
          new Set(
            result
              .map((asset: any) => asset.vendor)
              .filter((vendor: string) => vendor && vendor.trim() !== "")
          )
        ) as string[];

        const models = Array.from(
          new Set(
            result
              .map((asset: any) => asset.model)
              .filter((model: string) => model && model.trim() !== "")
          )
        ) as string[];

        // 🚀 Update unique values using generic approach
        setUniqueValues({
          device_type: deviceTypes.sort(),
          vendor: vendors.sort(),
          model: models.sort()
        });

        // 🚀 Update global variables for AG Grid custom filters
        globalDeviceTypes = deviceTypes.sort();
        globalVendors = vendors.sort();
        globalModels = models.sort();

        assetsRowDataRef.current = result; // ✅ keep ref in sync
        setAssetsRowData(result);

        if (result.some((device: any) => device.status === 3)) {
          if (!controller.signal.aborted) {
            await assetCount();
          }
        }
      }
    } catch (error: any) {
      if (error?.name !== "CanceledError" && error?.name !== "AbortError") {
        setIsLoading(false);
      }
    } finally {
      if (assetListRequestRef.current === controller) {
        assetListRequestRef.current = null;
        setIsLoading(false);
      }
    }
  };
  const fetchDecommsionedAssetsData = async () => {
    cancelAssetListRequest();
    const controller = new AbortController();
    assetListRequestRef.current = controller;
    setIsLoading(true);
    try {
      // NOTE: Previously fetched via GET from END_POINTS.DECOMM_DEVICE_LIST ('securityscan/decommissioned-devices').
      // Backend removed 'decommissioned-devices' API and consolidated the logic into 'decommission-recommission' (END_POINTS.DECOMMISSION_DEVICES).
      // It is now called using POST with payload { module: "decommissioned-devices" }.
      const response = await axiosInstance.post(
        END_POINTS.DECOMMISSION_DEVICES,
        {
          module: "decommissioned-devices",
        },
        {
          signal: controller.signal,
        }
      );
      if (controller.signal.aborted) {
        return;
      }
      if (response.status === 200) {
        const result = response.data?.data?.device_list || [];
        dataDecommissionMassage(result);

        // 🚀 Extract unique values for custom filters (decommissioned view)
        const deviceTypes = Array.from(
          new Set(
            result
              .map((asset: any) => asset.device_type)
              .filter((type: string) => type && type.trim() !== "")
          )
        ) as string[];

        const vendors = Array.from(
          new Set(
            result
              .map((asset: any) => asset.vendor)
              .filter((vendor: string) => vendor && vendor.trim() !== "")
          )
        ) as string[];

        const models = Array.from(
          new Set(
            result
              .map((asset: any) => asset.model)
              .filter((model: string) => model && model.trim() !== "")
          )
        ) as string[];

        // 🚀 Update unique values using generic approach
        setUniqueValues({
          device_type: deviceTypes.sort(),
          vendor: vendors.sort(),
          model: models.sort()
        });

        // 🚀 Update global variables for AG Grid custom filters
        globalDeviceTypes = deviceTypes.sort();
        globalVendors = vendors.sort();
        globalModels = models.sort();

        setAssetsRowData(result);
      }
    } catch (error: any) {
      if (error?.name !== "CanceledError" && error?.name !== "AbortError") {
        console.error("Error fetching decommissioned assets data:", error);
        setIsLoading(false);
      }
    } finally {
      if (assetListRequestRef.current === controller) {
        assetListRequestRef.current = null;
        setIsLoading(false);
      }
    }
  };
  const dataMassage = (data: any) => {
    data?.forEach((element: any) => {
      const securityScore = getSafeNumber(element.security_score);
      element.security_score_rounded = Math.floor(securityScore);
      element.vendor = makeFirstLetterCapital(element.vendor);
      const formattedDate = element.last_scan
        ? moment(element.last_scan).format("D, MMMM, YYYY")
        : "";
      element.last_scan_date = formattedDate;
      element.region_name = element.region_name
        ? element.region_name
        : "Unassigned";
      element.failed_count = getSafeNumber(
        element.vulnerability_levels?.failed_count,
        0
      );
    });
    data.sort((a: any, b: any) => {
      const dateA = a.last_scan ? new Date(a.last_scan).getTime() : 0;
      const dateB = b.last_scan ? new Date(b.last_scan).getTime() : 0;
      return dateB - dateA;
    });
    data.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
  };

  const dataDecommissionMassage = (data: any) => {
    data?.forEach((element: any) => {
      const securityScore = getSafeNumber(element.security_score);
      element.security_score_rounded = Math.floor(securityScore);
      element.vendor = makeFirstLetterCapital(element.vendor);
      element.decommission_on_sort =
        element.decommission_on || element.last_scan_date || element.last_scan;
      element.region_name = element.region_name
        ? element.region_name
        : "Unassigned";
      element.failed_count = getSafeNumber(
        element.vulnerability_levels?.failed_count,
        0
      );
    });
    data.sort((a: any, b: any) => {
      const dateA = a.decommission_on_sort
        ? new Date(a.decommission_on_sort).getTime()
        : 0;
      const dateB = b.decommission_on_sort
        ? new Date(b.decommission_on_sort).getTime()
        : 0;
      return dateB - dateA;
    });
    data.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
  };

  useEffect(() => {
    if (showDecommissioned) {
      fetchDecommsionedAssetsData();
    } else {
      fetchAssetsData();
    }
  }, [location.state?.id, showDecommissioned]);


  const makeFirstLetterCapital = (str: any) => {
    if (str) {
      return str.charAt(0).toUpperCase() + str.substring(1);
    } else {
      return "";
    }
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateSelectedRows([]);
    setShowDecommissioned(event.target.checked);
    if (event.target.checked) {
      setShowPreviousResources(false);
    }

    // 🚀 Reset filters when switching between active/decommissioned views
    setActiveFilters({
      device_type: [],
      vendor: [],
      model: []
    });

    setAssetsRowData([]);
    setIsLoading(true);
  };

  const handlePreviousResourcesCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateSelectedRows([]);
    const checked = event.target.checked;
    setShowPreviousResources(checked);
    if (checked && showDecommissioned) {
      setShowDecommissioned(false);
    } else if (assetsRowDataRef.current.length === 0) {
      fetchAssetsData();
    }
  };
  const handleExport = () => {
    const dataToExport = selectedRows.length > 0 ? selectedRows : assetsRowData;

    if (!dataToExport || dataToExport.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    try {
      // Prepare the data for export
      const exportData = dataToExport.map((row: any) => {
        const misconfigCount =
          row.status === 3
            ? (row.failed_count ?? row.vulnerability_levels?.failed_count ?? (typeof row.vulnerability === "number" ? row.vulnerability : 0))
            : 0;

        const lastScanFormatted =
          row.status === 3 && row.last_scan
            ? moment(row.last_scan).format("DD-MMMM-YYYY HH:mm:ss")
            : "-";

        const isDiscovery = row?.type?.toLowerCase() === "discovery";

        const swCount = row.windows_software_count ?? row.software_count;
        const softwareVal = isDiscovery
          ? (isZeroOrEmpty(swCount) ? "-" : swCount)
          : (swCount ?? "-");

        const secScoreVal = isDiscovery
          ? (isZeroOrEmpty(row.security_score) ? "-" : (row.status === 3 ? (!isNaN(Number(row.security_score)) ? Math.round(Number(row.security_score)) : 0) : 0))
          : (row.status === 3 ? (!isNaN(Number(row.security_score)) ? Math.round(Number(row.security_score)) : 0) : 0);

        const misconfigVal = isDiscovery
          ? (isZeroOrEmpty(misconfigCount) ? "-" : misconfigCount)
          : misconfigCount;

        const cveScoreVal = isDiscovery
          ? (isZeroOrEmpty(row.cve_score) ? "-" : (row.status === 3 ? (!isNaN(Number(row.cve_score)) ? Math.round(Number(row.cve_score)) : 0) : 0))
          : (row.status === 3 ? (!isNaN(Number(row.cve_score)) ? Math.round(Number(row.cve_score)) : 0) : 0);

        const cveVal = isDiscovery
          ? (isZeroOrEmpty(row.cve) ? "-" : (row.status === 3 ? (Math.round(Number(row.cve)) || 0) : 0))
          : (row.status === 3 ? (Math.round(Number(row.cve)) || 0) : 0);

        const baseRow: any = {
          "#": row.number,
          Name: row.device_name || "-",
          "IP Address": row.ip_address || "-",
          Vendor: row.vendor || "-",
          OS: row.model || "-",
          "OS Version": row.os_version || "-",
          Type: row.device_type || "-",
          Criticality: row.criticality || "-",
          "Open Ports": Array.isArray(row.discovery_ports) ? row.discovery_ports.length : 0,
          Software: softwareVal,
          "Security Score": secScoreVal,
          Misconfigurations: misconfigVal,
          "CVE Score": cveScoreVal,
          "CVE's": cveVal,
          "Last Scan": lastScanFormatted,
          Regions: row.region_name || "Unassigned",
        };

        // Add dynamic compliance framework columns (NIST, CIS, PCI), only frameworks switched on
        const frameworkKeys = Object.keys(row).filter(
          (key) => (key.startsWith("NIST_") || key.startsWith("CIS_") || key.startsWith("PCI") || key.startsWith("SPARK_")) && isFrameworkKeyOn(key)
        );

        if (frameworkKeys.length > 0) {
          frameworkKeys.forEach((key) => {
            baseRow[key] = row.status === 3 ? Math.round(Number(row[key]) || 0) : 0;
          });
        } else if (isFrameworkOn("NIST")) {
          const rawNist = row.NIST ?? row["NIST_800-53 r5"] ?? 0;
          baseRow["NIST"] = row.status === 3 ? Math.round(Number(rawNist) || 0) : 0;
        }

        return baseRow;
      });

      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

      // Generate and download the Excel file
      XLSX.writeFile(workbook, "AssetsData.xlsx");

      toast.success("Export to Excel triggered!");
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data.");
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElAction(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElAction(null);
  };
  const handleSelectionChange = (selectedRows: any) => {
    updateSelectedRows(selectedRows);
  };
  const isNotSchedulable = () => {
    return selectedRows.some((item) => item.schedule === "not_schedulable");
  };
  const anySelectedDeviceRequiresRescan = () => {
    return selectedRows.every((device) => device.rescan);
  };
  const unique_devices = useSelector(
    (state: any) => state.UserLoginDetails.unique_devices
  );
  const sso_enabled = useSelector(
    (state: any) => state.UserLoginDetails.sso_enabled
  );

  const handleReport = () => {
    setAssetDrawerOpen(false);
    setIsReportDialogOpen(true);
    //setReportDrawerOpen(true);
  };
  const handleAssetComplianceReport = () => {
    setAssetDrawerOpen(false);
    setReportDrawerOpen(true);
  };

  const handleScheduleScan = async () => {
    if (selectedRows.length > 0) {
      setDeviceIds(selectedRows.map((device) => device.id));
    }

    setIsAllScheduleable(
      selectedRows.every((item) => item.schedule === "schedulable")
    );

    // Reset all state variables to initial values
    setSelectedOption("0");
    setScheduleSelectedOption("new_schedule");
    formikScheduleScan.resetForm();

    try {
      const response = await axiosInstance.get(END_POINTS.SCHEDULE_FREQUENCY);
      if (response?.status === 200) {
        setScheduleOptionsFrequency(response?.data?.data?.frequency);
        setScheduleOptionsWeekly(response?.data?.data?.weekly);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
    setAnchorElAction(null);
    // Always start from the first popup
    setIsFirstPopupOpen(true);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let url = END_POINTS.SCHEDULE_LIST;
    if (timezone) {
      url += `?timezone=${timezone}`;
    }
    try {
      const schedule_response = await axiosInstance.get(url);
      if (schedule_response?.status === 200) {
        setScanSummaryData(schedule_response?.data?.data?.summary_data);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  };

  const handleCancelSchedule = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    setRemoveAllSchedules(false);
    setIsCancelSchedulePopupOpen(true);
  };

  const handleCancelScheduleClose = () => {
    setIsCancelSchedulePopupOpen(false);
    setRemoveAllSchedules(false); // Reset to default
  };

  const handleRemoveSchedule = async () => {
    const req = {
      device_ids_list: deviceIds,
      remove_all_schedules: removeAllSchedules,
    };

    try {
      const response = await axiosInstance.post(
        "securityscan/cancel-schedule",
        req
      );
      if (response.status === 200) {
        toast.success("Schedule canceled successfully!");
        setIsCancelSchedulePopupOpen(false);
        fetchAssetsData();
        updateSelectedRows([]);
      }
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Failed to cancel the schedule."
      );
    }
  };

  const handleDialogClose = () => {
    setIsReportDialogOpen(false);
  };

  const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const handleDownload = async () => {
    const eligibleAssets = selectedRows.filter((device: any) => {
      const type = device?.type?.toLowerCase();
      const scanType = device?.scan_type?.toLowerCase();
      return type !== "discovery" && scanType !== "discovery";
    });

    if (eligibleAssets.length === 0) {
      toast.error("Report download is not available for discovery assets.");
      setIsReportDialogOpen(false);
      return;
    }

    setDownloadLoading(true);
    const timeZone = getUserTimezone();

    const cloudAssets = eligibleAssets.filter((device: any) => isCloudAsset(device));
    const onPremAssets = eligibleAssets.filter((device: any) => !isCloudAsset(device));

    try {
      const requests = [];

      if (cloudAssets.length > 0) {
        const cloudPayload = {
          report_format: reportFormat,
          asset_ids: cloudAssets.map((device: any) => device.id),
          time_zone: timeZone,
          type: "asset_summary",
          module: "cloud",
        };
        requests.push(
          axiosInstance.post(END_POINTS.REPORT_DOWNLOAD, cloudPayload)
        );
      }

      if (onPremAssets.length > 0) {
        const onPremPayload = {
          report_format: reportFormat,
          asset_ids: onPremAssets.map((device: any) => device.id),
          time_zone: timeZone,
          type: "asset_summary",
          module: "on_premise",
        };
        requests.push(
          axiosInstance.post(END_POINTS.REPORT_DOWNLOAD, onPremPayload)
        );
      }

      const responses = await Promise.all(requests);
      const allSuccess = responses.every((res: any) => res.status === 200);

      if (allSuccess) {
        toast.success(
          "Report request submitted, please check Reports section."
        );
        setDeviceIds([]);
        if (gridApiRef.current && gridApiRef.current.api) {
          gridApiRef.current.api.deselectAll();
        }
        updateSelectedRows([]);
      } else {
        toast.error("Failed to download the report.");
      }
    } catch (error: any) {
      if (gridApiRef.current && gridApiRef.current.api) {
        gridApiRef.current.api.deselectAll();
      }
      updateSelectedRows([]);
      toast.error(
        error.response?.data?.message ||
          (typeof error.response?.data === "string" ? error.response.data : "") ||
          "Something went wrong",
        { type: "error" }
      );
    } finally {
      setDownloadLoading(false);
      setIsReportDialogOpen(false);
    }
  };

  // Helper: recursively search a regions tree for a node matching by id or label
  const findRegionInTree = (
    nodes: any[],
    regionId: any,
    regionName: string
  ): { id: any; parentIds: string[] } | null => {
    const search = (list: any[], ancestors: string[]): { id: any; parentIds: string[] } | null => {
      for (const node of list) {
        // Prefer direct id match, fall back to label match
        if (
          (regionId && node.id === regionId) ||
          (!regionId && regionName && node.label?.toLowerCase() === regionName?.toLowerCase())
        ) {
          return { id: node.id, parentIds: ancestors };
        }
        if (node.data?.length) {
          const found = search(node.data, [...ancestors, node.id]);
          if (found) return found;
        }
      }
      return null;
    };
    return search(nodes, []);
  };

  const handleChangeLocation = async () => {
    const response = await axiosInstance.get(
      END_POINTS.GLOBAL_DASHBOARD_REGION
    );
    const regionsList = response?.data?.data?.regions_list || [];
    if (response?.status === 200) {
      setOriginalRegions(regionsList);
      setCurrentRegions(regionsList);
    }

    // Pre-select the currently selected asset's own location
    const currentAsset = selectedRows?.[0];
    const assetRegionId = currentAsset?.region_id ?? null;
    const assetRegionName = currentAsset?.region_name ?? "";

    // Only pre-select if the asset has a real location (not "Unassigned" / empty)
    const hasRealLocation =
      assetRegionId ||
      (assetRegionName && assetRegionName.toLowerCase() !== "unassigned");

    if (hasRealLocation) {
      const match = findRegionInTree(regionsList, assetRegionId, assetRegionName);
      if (match) {
        setSelectedRegionId(match.id);
        // Expand all ancestor nodes so the pre-selected item is visible
        const expandMap: Record<string, boolean> = {};
        match.parentIds.forEach((pid) => { expandMap[pid] = true; });
        setExpanded(expandMap);
      } else {
        setSelectedRegionId(null);
        setExpanded({});
      }
    } else {
      // Asset has no real location — open with nothing pre-selected
      setSelectedRegionId(null);
      setExpanded({});
    }

    setAnchorElAction(null);
    toggleDrawer(true);
  };

  const handleCancel = () => {
    setIsFirstPopupOpen(false);

    setSelectedOption("0");
  };

  const handleNext = () => {
    setIsFirstPopupOpen(false);
    setIsSecondPopupOpen(true);
  };

  const handleSecondPopupClose = () => {
    formikScheduleScan.resetForm();
    setIsSecondPopupOpen(false);
    setSelectedItem(null);
    setIsFirstPopupOpen(false);
    setSelectedOption("0");
  };

  const handleRescanMulti = () => {
    if (hasActiveAgent !== true) {
      toast.error("Agent is not active. Please ensure the agent is active before rescanning.");
      return;
    }

    setDeviceIds(selectedRows.map((device) => device.id));
    if (selectedRows.some((device: any) => device.type?.toLowerCase() === "discovery")) {
      setDiscoveryRescanRowData(selectedRows);
      setIsDiscoveryRescanOpen(true);
    } else {
      handleRescanWithCredential();
    }
  };

  const handleMapMulti = () => {
    setDeviceIds(selectedRows.map((device) => device.id));
    handleMap();
  };

  const isDecommissionExcludedVendor = (vendor?: string) => {
    // const normalizedVendor = (vendor || "").toLowerCase();
    // return ["microsoft", "windows"].includes(normalizedVendor);
    return false;
  };

  const headerActions = (
    <Box display="flex" alignItems="center" gap={1}>
      {!showDecommissioned && (
        <Button
          onClick={handleExport}
          //  startIcon={<FileDownloadOutlinedIcon />}
          disabled={selectedRows.length === 0}
          sx={{
            opacity: selectedRows.length === 0 ? 0.5 : 1,
            backgroundColor: isDarkMode
              ? "#1E1E1E !important"
              : "#ffffff !important",
            "&:hover": {
              backgroundColor: "#0F02C3",
              color: "white",
            },
          }}
        >
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <img src={isDarkMode ? xlsIcon_dark : xlsIcon} />
            Export To Excel
          </Typography>
        </Button>
      )}
      {!showDecommissioned &&
        hasPermissions(ROLES_CONTENT_PROPS.DOWNLOAD_REPORT) && (
          <Button
            onClick={handleReport}
            disabled={selectedRows.length === 0 || reportEligibleAssets.length === 0}
            sx={{
              opacity: selectedRows.length === 0 || reportEligibleAssets.length === 0 ? 0.5 : 1,
              backgroundColor: isDarkMode
                ? "#1E1E1E !important"
                : "#ffffff !important",
              "&:hover": {
                backgroundColor: "#0F02C3",
                color: "white",
              },
            }}
          >
            <Typography
              variant="body2"
              fontWeight={500}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <img src={isDarkMode ? downloadIcon_dark : downloadIcon} />
              Report
            </Typography>
          </Button>
        )}
      <Dialog
        open={isReportDialogOpen}
        onClose={handleDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "360px",
            height: "300px",
            borderRadius: "4px",
            transform: "translate(-50%, -50%)",
            // padding: "10px 10px 0",
            padding: "10px",
            boxSizing: "border-box",
            overflow: "hidden", // ✅ Prevent scrollbars
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#101828",
          }}
        >
          {environmentFilter === "cloud"
            ? "Download Resource Summary Report?"
            : "Download Asset Summary Report?"}
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.mode === "dark" ? "#b0b0b0" : "#667085",
            overflow: "visible", // prevent scrollbar
            maxHeight: "none", // override default
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, color: theme.palette.mode === "dark" ? "#b0b0b0" : "#666666" }}>
            This report offers a summary of essential information for {reportEligibleAssets.length}{" "}
            {environmentFilter === "cloud" ? "Resource's" : "Asset's"}.
          </Typography>
          <Typography
            variant="body2"
            fontWeight={500}
            align="center"
            sx={{ mb: 2, fontWeight: "bold" }}
          >
            Report Format
          </Typography>
          <RadioGroup
            value={reportFormat}
            onChange={(e) => setReportFormat(e.target.value)}
            row
            sx={{ justifyContent: "center" }}
          >
            <FormControlLabel value="pdf" control={<Radio />} label="Pdf" />
            <FormControlLabel value="excel" control={<Radio />} label="Excel" />
          </RadioGroup>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "24px",
            // marginTop: "12px",
          }}
        >
          <Button
            onClick={handleDialogClose}
            variant="outlined"
            sx={{ width: 130 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDownload}
            variant="contained"
            color="primary"
            disabled={downloadLoading || reportEligibleAssets.length === 0}
            sx={{ width: 130 }}
          >
            {downloadLoading ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={10} sx={{ color: "white" }} />
                <Typography sx={{ color: "white", fontSize: "11px" }}>
                  Downloading...
                </Typography>
              </Box>
            ) : (
              "Download"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Disable actions when any selected asset is still scanning (status !== 3) or when in cloud view */}
      {(() => {
        const anySelectedScanning = selectedRows.some((r: any) => r?.status !== 3);
        const hasCloudSelected = selectedRows.some((r: any) => isCloudAsset(r));

        const isDisabled =
          environmentFilter === "cloud" ||
          selectedRows.length === 0 ||
          (showDecommissioned && selectedRows.length > 1) ||
          anySelectedScanning ||
          hasCloudSelected;

        return (
          <Button
            variant="outlined"
            onClick={handleMenuOpen}
            color="primary"
            disabled={isDisabled}
            sx={{
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? "not-allowed" : "pointer",
              backgroundColor: isDarkMode
                ? "#1E1E1E !important"
                : "#ffffff !important",
              "&:hover": {
                backgroundColor: isDisabled
                  ? (isDarkMode ? "#1E1E1E !important" : "#ffffff !important")
                  : "#0F02C3",
                color: isDisabled ? "inherit" : "white",
              },
            }}
          >
            <Typography
              sx={{ display: "flex", alignItems: "center" }}
              variant="body2"
              fontWeight={500}
            >
              Actions{" "}
              <ArrowDropDownIcon sx={{ color: isDarkMode ? "#3F65ED" : "blue" }} />
            </Typography>
          </Button>
        );
      })()}
      <Menu
        id="basic-menu"
        anchorEl={anchorElAction}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {!showDecommissioned && (() => {
          const isCloudOnly = selectedRows.some(
            (row: any) => isCloudAsset(row) || row?.type === "cloud"
          );
          if (isCloudOnly) {
            return null;
          }
          return (
            <>
              {!isNotSchedulable() &&
                selectedRows.length > 0 &&
                hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
                hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) && (
                  <>
                    <MenuItem onClick={handleScheduleScan}>
                      Schedule Scan
                    </MenuItem>
                    <MenuItem onClick={handleCancelSchedule}>
                      Cancel Schedule
                    </MenuItem>
                  </>
                )}
              {hasPermissions(ROLES_CONTENT_PROPS.DECOMMISSION_DEVICE) &&
                selectedRows.length > 0 &&
                selectedRows.every(row => row?.type?.toLowerCase() !== "discovery" && row?.scan_type?.toLowerCase() !== "discovery" && !isDecommissionExcludedVendor(row.vendor)) && (
                  <MenuItem onClick={handleMultipleDecommission}>
                    Decommission
                  </MenuItem>
                )}
              {hasPermissions(ROLES_CONTENT_PROPS.MODIFIY_DEVICE_LOCATION) &&
                selectedRows.length > 0 && (
                  <MenuItem onClick={handleChangeLocation}>
                    Change Location
                  </MenuItem>
                )}
              {false && hasPermissions(ROLES_CONTENT_PROPS.DELETE_DEVICE) &&
                selectedRows.length > 0 && (
                  <MenuItem
                    sx={{
                      color: "error.main",
                      "&:hover": {
                        backgroundColor: "error.lighter",
                      },
                    }}
                    onClick={handleDeleteDialogOpen}
                  >
                    Delete Assets
                  </MenuItem>
                )}
              {anySelectedDeviceRequiresRescan() &&
                hasPermissions(ROLES_CONTENT_PROPS.CREDENTIAL_MANAGER) &&
                selectedRows.length > 0 && (
                  <MenuItem onClick={handleMapMulti}>Map credential</MenuItem>
                )}
              {selectedRows.length > 0 &&
                selectedRows.some((row: any) => canMapTemplateToAsset(row)) && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleMapTemplate(selectedRows);
                    }}
                  >
                    Map Config Template
                  </MenuItem>
                )}
              {!selectedRows.some((device: any) => isCloudAsset(device)) && (
                <MenuItem onClick={handleAssetCriticalityDialogOpen}>
                  Asset Criticality
                </MenuItem>
              )}
            </>
          );
        })()}
        {showDecommissioned &&
          selectedRows.length === 1 &&
          !isDecommissionExcludedVendor(selectedRows[0]?.vendor) && (
            <MenuItem onClick={handleMultipleCommission}>Commission</MenuItem>
          )}
      </Menu>
      {environmentFilter === "cloud" ? (
        <>
          <Typography sx={{ fontWeight: "700", fontSize: "12px" }}>
            Previous Resources
          </Typography>
          <Checkbox checked={showPreviousResources} onChange={handlePreviousResourcesCheckboxChange} />
          {/* Show Decommissioned Assets hidden for cloud */}
        </>
      ) : (
        <>
          <Typography sx={{ fontWeight: "700", fontSize: "12px" }}>
            Show Decommissioned Assets
          </Typography>
          <Checkbox checked={showDecommissioned} onChange={handleCheckboxChange} />
        </>
      )}
    </Box>
  );

  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuKebabClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isCloudAsset(selectedAssetSideNav)) {
      return;
    }
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuKebabClose = () => {
    setMenuAnchorEl(null);
  };

  const handleShowConfig = (deviceId: any, selectDevice: any) => {
    dispatch(
      authActions.setAssetsData({
        tempAssetName: selectDevice.device_name,
      })
    );
    navigate(`/on-premises/new-assets/${deviceId}`);
  };

  const handleMenuAction = (action: string) => {
    switch (action) {
      case "DeCommission":
        if (selectedAssetSideNav?.id) {
          setDeviceIds([selectedAssetSideNav.id]);
          setIsDecommissionDialogOpen(true);
        }
        break;
      case "ShowConfigDiff":
        if (selectedAssetSideNav?.id) {
          dispatch(
            setConfigDiffData({
              rowData: selectedAssetSideNav,
              device_id: String(selectedAssetSideNav.id),
              click: "assets",
            })
          );
          setAssetDrawerOpen(false);
          navigate("/on-premises/configdiff", {
            state: { device_id: selectedAssetSideNav.id },
          });
        }
        break;
      case "ChangeLocation":
        if (selectedAssetSideNav?.id) {
          setSelectedRows([selectedAssetSideNav]);
          handleChangeLocation();
        }
        break;
      case "DeleteAssets":
        if (selectedAssetSideNav?.id) {
          setSelectedRows([selectedAssetSideNav]);
          setDeviceIds([selectedAssetSideNav.id]);
          setIsDeleteDialogOpen(true);
        }
        break;
      case "AssetCriticality":
        if (selectedAssetSideNav?.id) {
          getAssetCriticality();
          setDeviceIds([selectedAssetSideNav.id]);
          setIsAssetCriticalityDialogOpen(true);
        }
        break;
      case "ScheduleScan":
        if (selectedAssetSideNav?.id) {
          setDeviceIds([selectedAssetSideNav.id]);
          setIsAllScheduleable(
            selectedAssetSideNav.schedule === "schedulable"
          );
          handleScheduleScan();
        }
        break;
      case "CancelSchedule":
        if (selectedAssetSideNav?.id) {
          setDeviceIds([selectedAssetSideNav.id]);
          setRemoveAllSchedules(false);
          setIsCancelSchedulePopupOpen(true);
        }
        break;
      case "RescanWithCredential":
        if (selectedAssetSideNav?.id) {
          setDeviceIds([selectedAssetSideNav.id]);
          handleRescanWithCredential();
        }
        break;
      case "MapCredential":
        if (selectedAssetSideNav?.id) {
          setDeviceIds([selectedAssetSideNav.id]);
          handleMap();
        }
        break;
      case "MapTemplate":
        if (selectedAssetSideNav?.id) {
          handleMapTemplate(selectedAssetSideNav);
        }
        break;
      case "Rescan":
        if (selectedAssetSideNav?.id) {
          handleRescan(selectedAssetSideNav.id);
        }
        break;
    }
    handleMenuKebabClose();
    setAssetDrawerOpen(false);
  };
  const [showMenu, setShowMenu] = useState(true);
  const isSelectedAssetCloud = isCloudAsset(selectedAssetSideNav);
  const MenuKebabDrawer = isSelectedAssetCloud ? null : (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <IconButton
        size="small"
        onClick={handleMenuKebabClick}
        sx={{
          color: "text.secondary",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
          anchorEl={menuAnchorEl}
          open={menuOpen}
          onClose={handleMenuKebabClose}
          onClick={(e) => e.stopPropagation()}
          PaperProps={{
            sx: {
              width: 260,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
        {/* Schedule Scan */}
        {selectedAssetSideNav?.schedule !== "not_schedulable" &&
          hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
          hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
          (selectedAssetSideNav?.schedule === "scheduled" ||
            selectedAssetSideNav?.schedule === "schedulable") && (
            <MenuItem
              onClick={() => handleMenuAction("ScheduleScan")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Schedule Scan
            </MenuItem>
          )}
        {/* Cancel Schedule */}
        {hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE) &&
          hasPermissions(ROLES_CONTENT_PROPS.SCHEDULE_CREATE_MODIFY) &&
          selectedAssetSideNav?.schedule === "scheduled" && (
            <MenuItem
              onClick={() => handleMenuAction("CancelSchedule")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Cancel Schedule
            </MenuItem>
          )}
        {/* Decommission */}
        {hasPermissions(ROLES_CONTENT_PROPS.DECOMMISSION_DEVICE) &&
          selectedAssetSideNav?.type?.toLowerCase() !== "discovery" &&
          selectedAssetSideNav?.scan_type?.toLowerCase() !== "discovery" &&
          !isDecommissionExcludedVendor(selectedAssetSideNav?.vendor) && (
            <MenuItem
              onClick={() => handleMenuAction("DeCommission")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Decommission
            </MenuItem>
          )}
        {/* Change Location */}
        {hasPermissions(ROLES_CONTENT_PROPS.MODIFIY_DEVICE_LOCATION) && (
            <MenuItem
              onClick={() => handleMenuAction("ChangeLocation")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Change Location
            </MenuItem>
          )}
        {/* Delete Assets */}
        {false && hasPermissions(ROLES_CONTENT_PROPS.DELETE_DEVICE) && (
          <MenuItem
            onClick={() => handleMenuAction("DeleteAssets")}
            sx={{
              color: "error.main",
              "&:hover": {
                backgroundColor: "error.lighter",
              },
              fontSize: 13,
              py: 0.5,
              minHeight: 32,
            }}
          >
            Delete Assets
          </MenuItem>
        )}

        {/* Rescan */}
        {hasPermissions(ROLES_CONTENT_PROPS.RESCAN_DEVICE) &&
          (selectedAssetSideNav?.type?.toLowerCase() === "discovery" ||
            (selectedAssetSideNav?.rescan && selectedAssetSideNav?.status === 3)) && (
            <MenuItem
              onClick={() => handleMenuAction("Rescan")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Rescan
            </MenuItem>
          )}
        {/* Map credential */}
        {hasPermissions(ROLES_CONTENT_PROPS.CREDENTIAL_MANAGER) &&
          selectedAssetSideNav?.type?.toLowerCase() !== "discovery" &&
          selectedAssetSideNav?.rescan && (
            <MenuItem
              onClick={() => handleMenuAction("MapCredential")}
              sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
            >
              Map credential
            </MenuItem>
          )}
        {/* Map Config Template — network on-prem devices only (same gate as New Scan) */}
        {canMapTemplateToAsset(selectedAssetSideNav) && (
          <MenuItem
            onClick={() => handleMenuAction("MapTemplate")}
            sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
          >
            Map Config Template
          </MenuItem>
        )}
        {/* Asset Criticality */}
        {!isCloudAsset(selectedAssetSideNav) && (
          <MenuItem
            onClick={() => handleMenuAction("AssetCriticality")}
            sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
          >
            Asset Criticality
          </MenuItem>
        )}
      </Menu>
    </Box>
  );

  const handleReset = () => {
    setCurrentRegions(originalRegions);
    setSelectedRegionId(null);
    setExpanded({});
  };

  const handleSave = async () => {
    if (selectedRegionId && selectedRows?.length > 0) {
      const payload = {
        region_id: selectedRegionId,
        device_id: selectedRows.map((device) => device.id),
      };
      try {
        const response = await axiosInstance.post(
          END_POINTS.UPDATE_DEVICE,
          payload
        );
        if (response.status === 200) {
          toast.success(response.data.message);
          setOpenSideNav(false);
          setSelectedRegionId(null);
          setExpanded({});
          fetchAssetsData();
          updateSelectedRows([]);
        }
      } catch (error: any) {
        toast.error(
          error.response.data
            ? error.response.data.message
            : "Something went wrong",
          { type: "error" }
        );
      }
    }
  };

  const RegionTree = ({ nodes, selectedId, setSelectedId }: any) => {
    const toggleExpand = (id: any) => {
      setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const handleRadioChange = (id: any) => {
      setSelectedId(id);
    };

    const renderTree = (node: any, isLastChild: any) => (
      <li key={node.id} style={{ marginBottom: 8 }}>
        {/* Expand/Collapse Icon */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {" "}
          {node.data?.length > 0 && (
            <span
              onClick={() => toggleExpand(node.id)}
              style={{
                cursor: "pointer",
                marginRight: 8,
                display: "inline-block",
                width: 16,
                textAlign: "center",
              }}
            >
              {expanded[node.id] ? "▼" : "▶"}
            </span>
          )}
          {/* Radio Button and Label */}
          <label
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: "1.2rem",
              fontWeight: "500",
            }}
          >
            {isLastChild && (
              <input
                type="radio"
                name="region"
                checked={selectedId === node.id}
                onChange={() => handleRadioChange(node.id)}
                style={{ marginRight: 8, transform: "scale(1.5)" }}
              />
            )}
            {node.label}
          </label>
        </div>

        {/* Render Children */}
        {expanded[node.id] && node.data?.length > 0 && (
          <ul style={{ listStyle: "none", paddingLeft: 20 }}>
            {node.data.map((childNode: any) => {
              const isLastChild =
                !childNode.data || childNode.data.length === 0;
              return (
                <li
                  key={childNode.id}
                  style={{ marginBottom: isLastChild ? 0 : 8 }}
                >
                  {renderTree(childNode, isLastChild)}
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );

    return (
      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {nodes.map((node: any) => {
          const isLastChild = !node.data || node.data.length === 0;
          return (
            <li key={node.id} style={{ marginBottom: isLastChild ? 0 : 8 }}>
              {renderTree(node, isLastChild)}
            </li>
          );
        })}
      </ul>
    );
  };

  // const RegionTree = ({ nodes, selectedId, setSelectedId }:any) => {
  //   const [expanded, setExpanded] = useState<Record<string, boolean>>({});

  //   const toggleExpand = (id:any) => {
  //     setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  //   };

  //   return (
  //     <ul style={{ listStyle: 'none', paddingLeft: 20 }}>
  //       {nodes.map((node:any) => (
  //         <li key={node.id}>
  //           {node.data?.length > 0 && (
  //             <span onClick={() => toggleExpand(node.id)} style={{ cursor: 'pointer' }}>
  //               {expanded[node.id] ? '▼' : '▶'}
  //             </span>
  //           )}
  //           <label style={{ marginLeft: 4 }}>
  //             <input
  //               type="radio"
  //               name="region"
  //               checked={selectedId === node.id}
  //               onChange={() => setSelectedId(node.id)}
  //             />
  //             {node.label}
  //           </label>
  //           {expanded[node.id] && node.data && (
  //             <RegionTree nodes={node.data} selectedId={selectedId} setSelectedId={setSelectedId} />
  //           )}
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  // const RegionTree = ({ nodes, selectedId, setSelectedId }: any) => {
  //   const renderTree = (node: any) => (
  //     <li key={node.id}>
  //       <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  //         <Radio
  //           checked={selectedId === node.id}
  //           onChange={() => setSelectedId(node.id)}
  //           value={node.id}
  //           size="small"
  //         />
  //         {node.label}
  //       </label>
  //       {Array.isArray(node.data) && node.data.length > 0 && (
  //         <ul>
  //           {node.data.map((childNode: any) => renderTree(childNode))}
  //         </ul>
  //       )}
  //     </li>
  //   );

  //   return (
  //     <ul>
  //       {nodes.map((node: any) => renderTree(node))}
  //     </ul>
  //   );
  // };

  const DrawerList = (
    <Box
      sx={{
        width: 400,
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Change Location</Typography>
        <Box>
          <Button onClick={handleReset} color="secondary" sx={{ mr: 1 }}>
            Reset
          </Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </Box>
      </Box>

      <TextField
        variant="outlined"
        placeholder="Search..."
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        onChange={(e) => {
          const searchValue = e.target.value.toLowerCase();
          if (searchValue) {
            const filterRegions = (regions: any[]): any[] => {
              return regions
                .map((region) => {
                  if (region.label.toLowerCase().includes(searchValue)) {
                    setExpanded((prev) => ({ ...prev, [region.id]: true }));
                    return region;
                  }
                  if (region.data?.length) {
                    const filteredChildren = filterRegions(region.data);
                    if (filteredChildren.length) {
                      setExpanded((prev) => ({ ...prev, [region.id]: true }));
                      return { ...region, data: filteredChildren };
                    }
                  }
                  return null;
                })
                .filter(Boolean);
            };
            setCurrentRegions(filterRegions(originalRegions));
          } else {
            setCurrentRegions(originalRegions);
            setExpanded({});
          }
        }}
      />

      <Divider sx={{ mb: 2 }} />

      {/* Region Tree */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <RegionTree
          nodes={currentRegions}
          selectedId={selectedRegionId}
          setSelectedId={setSelectedRegionId}
        />
      </Box>
    </Box>
  );

  const formikDecommission = useFormik({
    initialValues: {
      password: "",
      reason: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().when([], {
        is: () => !sso_enabled,
        then: (schema) =>
          schema
            .required("Password is required")
            .min(8, "Password must be at least 8 characters")
            .max(20, "Password must not exceed 20 characters")
            .matches(
              /[A-Z]/,
              "Password must contain at least one uppercase letter"
            )
            .matches(
              /[a-z]/,
              "Password must contain at least one lowercase letter"
            )
            .matches(/[0-9]/, "Password must contain at least one number")
            .matches(
              /[@$!%*?&#]/,
              "Password must contain at least one special character (@$!%*?&#)"
            )
            .matches(/^[^\s]+$/, "Password cannot contain spaces"),
        otherwise: (schema) => schema.notRequired(),
      }),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters")
        .test(
          "no-only-whitespace",
          "Reason cannot be only whitespace",
          (value) => (value ? value.trim().length > 0 : false)
        )
        .matches(
          /^[^\s][\s\S]*[^\s]$/,
          "Reason cannot start or end with whitespace"
        ),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        let passwordValidationResponse = { status: 200 };
        if (!sso_enabled && values.password) {
          const Password_encrypt = {
            password: doEncryptLogin(values.password),
          };
          passwordValidationResponse = await axiosInstance.post(
            END_POINTS.PASSWORD_CONFIRMATION,
            Password_encrypt
          );
        }
        if (passwordValidationResponse.status === 200) {
          const decommissionPayload = {
            device_id: deviceIds,
            action: "decommission",
          };
          const decommissionResponse = await axiosInstance.post(
            END_POINTS.DECOMMISSION_DEVICES,
            decommissionPayload
          );
          if (decommissionResponse.status === 200) {
            toast.success("Assets decommissioned successfully!");
            setIsDecommissionDialogOpen(false);
            setDeviceIds([]);
            updateSelectedRows([]);
            if (gridApiRef.current && gridApiRef.current.api) {
              gridApiRef.current.api.deselectAll();
            }
            // fetchAssetsData();  // calling fetchAssetsData through the socket handle in the global level 
            formikDecommission.resetForm();
            assetCount();
          } else {
            toast.error("Failed to decommission devices.");
            // Show error toast only if not already shown recently
            if (
              lastErrorMessageRef.current !==
              "Failed to decommission devices." ||
              !toastTimeoutRef.current
            ) {
              toast("Failed to decommission devices.", { type: "error" });
              lastErrorMessageRef.current = "Failed to decommission devices.";
              if (toastTimeoutRef.current) {
                clearTimeout(toastTimeoutRef.current);
              }
              toastTimeoutRef.current = setTimeout(() => {
                toastTimeoutRef.current = null;
                lastErrorMessageRef.current = null;
              }, toastDuration);
            }
            setIsButtonDisabled(false);
          }
        } else {
          // Show error toast only if not already shown recently
          if (
            lastErrorMessageRef.current !== "Invalid password." ||
            !toastTimeoutRef.current
          ) {
            toast("Invalid password.", { type: "error" });
            lastErrorMessageRef.current = "Invalid password.";
            if (toastTimeoutRef.current) {
              clearTimeout(toastTimeoutRef.current);
            }
            toastTimeoutRef.current = setTimeout(() => {
              toastTimeoutRef.current = null;
              lastErrorMessageRef.current = null;
            }, toastDuration);
          }
          setIsButtonDisabled(false);
        }
      } catch (errorMessage: any) {
        const errorMsg =
          errorMessage.response?.data?.message || "Something went wrong.";
        // Show error toast only if not already shown recently
        if (
          lastErrorMessageRef.current !== errorMsg ||
          !toastTimeoutRef.current
        ) {
          toast(errorMsg, { type: "error" });
          lastErrorMessageRef.current = errorMsg;
          if (toastTimeoutRef.current) {
            clearTimeout(toastTimeoutRef.current);
          }
          toastTimeoutRef.current = setTimeout(() => {
            toastTimeoutRef.current = null;
            lastErrorMessageRef.current = null;
          }, toastDuration);
        }
        setIsButtonDisabled(false);
      } finally {
        setIsButtonDisabled(false);
        setLoading(false);
        fetchAssetsData();
        assetCount();

        eventEmitter.emit("filterSaved", {});
      }
    },
    validateOnBlur: true,
    validateOnChange: true,
  });

  const formikCommission = useFormik({
    initialValues: {
      password: "",
      reason: "",
      cred_id: "",
      agent_id: "",
      rescanImmediately: true,
    },
    validationSchema: Yup.object({
      password: Yup.string().when([], {
        is: () => !sso_enabled,
        then: (schema) => schema.required("Password is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters")
        .matches(
          /^[^\s][\s\S]*[^\s]$/,
          "Reason cannot start or end with whitespace"
        ),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        let passwordValidationResponse = { status: 200 };
        if (!sso_enabled && values.password) {
          const Password_encrypt = {
            password: doEncryptLogin(values.password),
          };
          passwordValidationResponse = await axiosInstance.post(
            END_POINTS.PASSWORD_CONFIRMATION,
            Password_encrypt
          );
        }
        if (passwordValidationResponse.status === 200) {
          const isCloud = isCloudAsset(commissionRowData) || commissionRowData?.scan_source === "cloud" || commissionRowData?.type === "cloud" || environmentFilter === "cloud";

          if (isCloud) {
            if (values.rescanImmediately && deviceIds.length >= 1) {
              let successCount = 0;
              for (const devId of deviceIds) {
                const rescanPayload: any = {
                  device_id: devId,
                  scan_type: "aws_discovery_posture",
                  rescan_type: "cloud_single_resource",
                };
                if (values.cred_id) {
                  rescanPayload.cred_id = values.cred_id;
                }

                try {
                  const rescanResponse = await axiosInstance.post(
                    END_POINTS.RESCAN_RECOMMISSION,
                    rescanPayload
                  );
                  if (rescanResponse.status === 200) {
                    successCount++;
                  }
                } catch (err: any) {
                  console.error("Single resource rescan error for device", devId, err);
                }
              }

              if (successCount > 0) {
                toast.success(
                  `${deviceIds.length > 1 ? "Assets" : "Resource"} recommissioned and live cloud rescan initiated!`
                );
                setIsCommissionDialogOpen(false);
                setDeviceIds([]);
                updateSelectedRows([]);
                if (gridApiRef.current && gridApiRef.current.api) {
                  gridApiRef.current.api.deselectAll();
                }
                fetchDecommsionedAssetsData();
                fetchAssetsData();
                formikCommission.resetForm();
              } else {
                toast.error("Failed to initiate cloud rescan.");
              }
            } else {
              const commissionResponse = await axiosInstance.post(
                END_POINTS.DECOMMISSION_DEVICES,
                {
                  device_id: deviceIds,
                  action: "recommission",
                }
              );

              if (commissionResponse.status === 200) {
                toast.success("Assets commissioned successfully!");
                setIsCommissionDialogOpen(false);
                setDeviceIds([]);
                updateSelectedRows([]);
                if (gridApiRef.current && gridApiRef.current.api) {
                  gridApiRef.current.api.deselectAll();
                }
                fetchDecommsionedAssetsData();
                fetchAssetsData();
                formikCommission.resetForm();
              } else {
                toast.error("Failed to commission devices.");
              }
            }
            return;
          }

          setIsCommissionDialogOpen(false);
          //await assetCount();
          formikCommission.resetForm();

          // Check if device type is Endpoint
          const isSimplifiedAsset = isSimplifiedRecommissionAsset(commissionRowData);

          if (isSimplifiedAsset) {
            // Endpoint and supported network vendors use the simplified dialog.
            setSelectedRecommissionOption("ssh");
            setShowRecommissionOptions(true);
          } else if (commissionRowData.scan_source === "file") {
            // For non-Endpoint devices scanned via file
            setSelectedRecommissionOption("cancel");
            setShowRecommissionOptions(true);
          } else {
            // For non-Endpoint devices scanned via SSH/API
            setSelectedSSHAAPIOption("cancel");
            setShowSSHAPIOptions(true);
          }
        } else {
          // Show error toast only if not already shown recently
          if (
            lastErrorMessageRef.current !== "Invalid password." ||
            !toastTimeoutRef.current
          ) {
            toast.error("Invalid password.");
            lastErrorMessageRef.current = "Invalid password.";
            setIsButtonDisabled(true);
            if (toastTimeoutRef.current) {
              clearTimeout(toastTimeoutRef.current);
            }
            toastTimeoutRef.current = setTimeout(() => {
              toastTimeoutRef.current = null;
              lastErrorMessageRef.current = null;
              setIsButtonDisabled(false);
            }, toastDuration);
          }
        }
      } catch (error: any) {
        const errorMsg =
          error.response?.data?.message || "Something went wrong.";
        // Show error toast only if not already shown recently
        if (
          lastErrorMessageRef.current !== errorMsg ||
          !toastTimeoutRef.current
        ) {
          toast.error(errorMsg);
          lastErrorMessageRef.current = errorMsg;
          setIsButtonDisabled(true);
          if (toastTimeoutRef.current) {
            clearTimeout(toastTimeoutRef.current);
          }
          toastTimeoutRef.current = setTimeout(() => {
            toastTimeoutRef.current = null;
            lastErrorMessageRef.current = null;
            setIsButtonDisabled(false);
          }, toastDuration);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  const formikDelete = useFormik({
    initialValues: {
      password: "",
      reason: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().when([], {
        is: () => !sso_enabled,
        then: (schema) =>
          schema
            .required("Password is required")
            .min(8, "Password must be at least 8 characters")
            .max(20, "Password must not exceed 20 characters"),
        otherwise: (schema) => schema.notRequired(),
      }),
      reason: Yup.string()
        .required("Reason is required")
        .min(8, "Reason must be at least 8 characters")
        .max(120, "Reason must not exceed 120 characters"),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        let passwordValidationResponse = { status: 200 };
        if (!sso_enabled && values.password) {
          const Password_encrypt = {
            password: doEncryptLogin(values.password),
          };
          passwordValidationResponse = await axiosInstance.post(
            END_POINTS.PASSWORD_CONFIRMATION,
            Password_encrypt
          );
        }
        if (passwordValidationResponse.status === 200) {
          const payload = {
            device_id: selectedRows.map((device) => device.id),
            comment: values.reason,
          };
          const deleteResponse = await axiosInstance.post(
            END_POINTS.DELETE_DEVICES,
            payload
          );
          if (deleteResponse.status === 200) {
            toast.success("Assets deleted successfully!");
            setIsDeleteDialogOpen(false);
            setDeviceIds([]);
            updateSelectedRows([]);
            if (gridApiRef.current && gridApiRef.current.api) {
              gridApiRef.current.api.deselectAll();
            }
            fetchAssetsData();
            await assetCount();
            formikDelete.resetForm();
          }
        } else {
          // If error message is already shown, disable button until toast closes
          if (
            lastErrorMessageRef.current !== "Failed to delete assets." ||
            !toastTimeoutRef.current
          ) {
            toast.error("Failed to delete assets.");
            lastErrorMessageRef.current = "Failed to delete assets.";
            setIsButtonDisabled(true);
            if (toastTimeoutRef.current) {
              clearTimeout(toastTimeoutRef.current);
            }
            toastTimeoutRef.current = setTimeout(() => {
              toastTimeoutRef.current = null;
              lastErrorMessageRef.current = null;
              setIsButtonDisabled(false);
            }, toastDuration);
          }
          setLoading(false);
        }
      } catch (errorMessage: any) {
        const errorMsg =
          errorMessage.response?.data?.message || "Something went wrong.";
        // If error message is already shown, disable button until toast closes
        if (
          lastErrorMessageRef.current !== errorMsg ||
          !toastTimeoutRef.current
        ) {
          toast.error(errorMsg);
          lastErrorMessageRef.current = errorMsg;
          setIsButtonDisabled(true);
          if (toastTimeoutRef.current) {
            clearTimeout(toastTimeoutRef.current);
          }
          toastTimeoutRef.current = setTimeout(() => {
            toastTimeoutRef.current = null;
            lastErrorMessageRef.current = null;
            setIsButtonDisabled(false);
          }, toastDuration);
        }
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    validateOnBlur: true,
    validateOnChange: true,
  });

  const formikScheduleScan = useFormik({
    initialValues: {
      scanName: "",
      frequency: "",
      onDate: "",
      atTime: "",
      day: "",
      frequencyId: "",
      search: "",
    },
    validationSchema: Yup.object({
      scanName: Yup.string().required("Scan Name is required"),
      frequency: Yup.string().required("Frequency is required"),
      onDate: Yup.string().when("frequency", (frequency, schema) => {
        return !["Daily", "Hourly", "Weekly"].includes(String(frequency || ""))
          ? schema.required("Date is required")
          : schema.notRequired();
      }),
      day: Yup.string().when("frequency", (frequency, schema) => {
        return String(frequency) === "Weekly"
          ? schema.required("Day is required")
          : schema.notRequired();
      }),
      atTime: Yup.string().required("Time is required"),
    }),
    onSubmit: async (values) => {

      const convertToUTC = (time: string, date: string) => {
        if (time) {
          let utcDate;
          if (date) {
            const [day, month, year] = date.split("-").map(Number);
            const [hours, minutes] = time
              .split(/[: ]/)
              .map((value, index) =>
                index === 0 && time.includes("PM") && value !== "12"
                  ? +value + 12
                  : value === "12" && time.includes("AM")
                    ? 0
                    : +value
              );
            const localDate = new Date(year, month - 1, day, hours, minutes);
            utcDate = new Date(
              localDate.getUTCFullYear(),
              localDate.getUTCMonth(),
              localDate.getUTCDate(),
              localDate.getUTCHours(),
              localDate.getUTCMinutes(),
              localDate.getUTCSeconds()
            );
          } else {
            const now = new Date();
            const [hours, minutes] = time
              .split(/[: ]/)
              .map((value, index) =>
                index === 0 && time.includes("PM") && value !== "12"
                  ? +value + 12
                  : value === "12" && time.includes("AM")
                    ? 0
                    : +value
              );
            const localDate = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              hours,
              minutes
            );
            utcDate = new Date(
              localDate.getUTCFullYear(),
              localDate.getUTCMonth(),
              localDate.getUTCDate(),
              localDate.getUTCHours(),
              localDate.getUTCMinutes(),
              localDate.getUTCSeconds()
            );
          }
          const utcHours = String(utcDate.getHours()).padStart(2, "0");
          const utcMinutes = String(utcDate.getMinutes()).padStart(2, "0");
          const formattedTime = `${utcHours}:${utcMinutes}`;

          return formattedTime;
        }
      };

      const payload: any = {
        scan_name: values.scanName,
        frequency_id: values?.frequencyId,
        time: convertToUTC(
          values.atTime,
          values.onDate ? values.onDate.split("-").reverse().join("-") : ""
        ),
        device_ids: deviceIds,
        date: values.onDate ? values.onDate.split("-").reverse().join("-") : "",
      };
      if (values.frequency === "Weekly") {
        payload.day = values.day;
      }
      if (selectedOption && !isallScheduleable) {
        payload.remove_option = selectedOption;
      }
      schedule(payload)

    },
  });

  const schedule = async (payload: any) => {
    try {
      const response = await axiosInstance.post(
        END_POINTS.MY_SCAN_SCHEDULED_SCAN,
        payload
      );
      if (response?.status === 200) {
        toast.success(response.data.message);
        setIsSecondPopupOpen(false);
        setSelectedOption("0");
        formikScheduleScan.resetForm();
        fetchAssetsData();
        updateSelectedRows([]);
      }
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  }

  const updateRescan = async () => {
    const deviceId = rescanResponseData?.data?.device_list[0].id;
    if (deviceId && !latestRescanDevicesList.includes(deviceId)) {
      latestRescanDevicesList.push(deviceId);
    }
    const checkEligibleRescanDevices = assetsRowData?.filter(
      (item: any) => item.status < 3
    );
    checkEligibleRescanDevices?.forEach((item: any) => {
      if (item.id && !latestRescanDevicesList.includes(item.id)) {
        latestRescanDevicesList.push(item.id);
      }
    });
    // this.deviceService.rescanDeviceOrder(this.latestRescanDevicesList, this.rescanCallbackOrder);
    const payload = {
      device_uuids: latestRescanDevicesList,
    };
    const response = await axiosInstance.post(
      END_POINTS.DEVICE_MANAGEMENT_RESCAN,
      payload
    );
    if (response.status === 200) {
      rescanCallbackOrder(response?.data);
    } else {
      toast.error("Failed to rescan devices.");
    }
  };

  const rescanCallbackOrder = (response: any) => {
    toast.success(response.message, { type: "success" });
    setRescanResponseData(response);
    if (response?.data?.device_list?.[0]) {
      // ✅ Call fetchAssetsData ONCE to get fresh full data, then STOP the timer.
      // This means: device-list-od fires once → asset-list fires once → done.
      fetchAssetsData();
      if (intervalRequest.current) {
        clearInterval(intervalRequest.current);
        intervalRequest.current = null;
        setLatestRescanDevicesList([]);
      }
    }
  };

  const startTimer = () => {
    if (!intervalRequest.current) {
      intervalRequest.current = setInterval(() => {
        updateRescan();
      }, 25000);
    }
  };

  const isEligibleForTimer = () => {
    // ✅ Use ref instead of state — avoids stale closure inside the 25-second timer callback
    const dt = assetsRowDataRef.current.filter((item: any) => item.status < 3);
    if (dt.length === 0) {
      if (intervalRequest.current) {
        clearInterval(intervalRequest.current);
        intervalRequest.current = null;
        setLatestRescanDevicesList([]);
      }
    } else {
      startTimer();
    }
  };

  const updateDeviceInfo = (response: any) => {
    if (response && response?.length) {
      let data: any[] = assetsRowData?.length ? assetsRowData : [];
      if (data.length) {
        response.forEach((item: any) => {
          const findIndex = data.findIndex((itemObj: any) => {
            return itemObj.id === item.id;
          });
          if (findIndex !== -1) {
            const existingRow = data[findIndex];
            // ✅ MERGE: keep all existing fields (device_name, vendor, model, etc.)
            // and only override with non-null values from the incoming item.
            // This prevents empty rows when the API response has partial data.
            data[findIndex] = {
              ...existingRow,
              ...item,
              criticality: existingRow.criticality, // always preserve
              last_scan: existingRow.last_scan,      // preserve so row stays in place
            };
          }
        });
        dataMassage(data);
        assetsRowDataRef.current = [...data]; // ✅ keep ref in sync
        setAssetsRowData([...data]);
        startTimer();
      }
    }
  };

  const selectedFrequency = formikScheduleScan.values.frequency;
  const rescanWithCredential = (response: any) => {
    updateSelectedRows([]);
    updateDeviceInfo(response);
  };

  const mapCallback = (response: any) => {
    console.log("Re-scan with credential triggered", response);
    updateSelectedRows([]);
    fetchAssetsData();
    // updateDeviceInfo(response);
  };

  // 🚀 Runs once on mount — reference data & event listeners unrelated to filter state changes
  useEffect(() => {
    fetchCredentialstypes();
    getAssetCriticality();
    fetchCloudAgentStatus();

    const handleFilterSaved = (response: any) => {
      console.log("Filter saved event received:", response);
      updateSelectedRows([]);
      setAssetsRowData([]);
      setIsLoading(true);
      if (showDecommissioned) {
        if (environmentFilter === "cloud") {
          fetchAssetsData();
        } else {
          fetchDecommsionedAssetsData();
        }
      } else {
        fetchAssetsData();
      }
    };
    eventEmitter.on("filterSaved", handleFilterSaved);
    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);
  useEffect(() => {
    const assetsDetails = assetsRowData
      .filter((data: any) => {
        return data.device_type !== "Endpoint"; // filter condition
      })
      .map((data: any) => ({
        device_name: data.device_name,
        device_id: data.id,
      }));
    dispatch(
      authActions.updateAssetsList(assetsDetails)
    );
  }, [assetsRowData, dispatch]);

  return (
    <Box
      className={isDarkMode ? "dark-mode" : ""}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: 1.5,
      }}
    >
      {/* Toggle Bar */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box className="ds-toggle-bar">
          <button
            className={`ds-toggle-btn ${environmentFilter === "on_prem" ? "ds-toggle-btn--active" : ""}`}
            onClick={() => handleTabChange("on_prem")}
            id="asset-tab-onprem"
            style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            {environmentFilter === "on_prem" && (
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#1976d2",
                  display: "inline-block",
                }}
              />
            )}
            On-Prem
          </button>
          <button
            className={`ds-toggle-btn ${environmentFilter === "cloud" ? "ds-toggle-btn--active" : ""}`}
            onClick={() => handleTabChange("cloud")}
            id="asset-tab-cloud"
            style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            {environmentFilter === "cloud" && (
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#f97316",
                  display: "inline-block",
                }}
              />
            )}
            Cloud
          </button>
        </Box>
      </Box>

      <Card
        variant="outlined"
        sx={{
          height: "calc(100vh - 165px)",
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AgGridTable
          // key={showDecommissioned ? 'decommissioned' : 'active'}
          // 🚀 Removed dynamic key to prevent unmount/remount flickering when switching views
          columnDefs={
            showDecommissioned
              ? decommissionColumnDefs
              : assetsColumnDefs
          }
          data={filteredAssetsRowData}
          height={"calc(100vh - 165px)"}
          showSearch={true}
          headerActions={headerActions}
          searchPlaceholder={environmentFilter === "cloud" ? "Search Resources" : "Search Assets"}
          activeFilters={activeFilters}
          onRowClick={
            showDecommissioned
              ? undefined
              : handleScanRowClick
          }
          isLoading={isLoading}
          isRowSelectable={true}
          rowSelection="multiple"
          onSelectionChange={handleSelectionChange}
          gridOptions={gridOptions}
          gridRef={gridApiRef}
        />
      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        anchorReference="anchorPosition"
        anchorPosition={popoverPosition || { top: 0, left: 0 }}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        // transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: { p: 0, boxShadow: 3, borderRadius: 2 },
          // onMouseLeave: handlePopoverClose,
        }}
        disableRestoreFocus
      >
        {popoverContent}
      </Popover>
      <Dialog
        open={isDecommissionDialogOpen}
        onClose={handleDecommissionDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "450px",
            maxHeight: "90vh",
            borderRadius: "4px",
            transform: "translate(-50%, -50%)",
            padding: "10px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 900,
            fontSize: "18px",
            color: isDarkMode ? "#fff" : "#101828",
            flexShrink: 0,
          }}
        >
          Are you sure you want to decommission?
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "14px",
            color: "#667085",
            mt: "4px",
            pb: 0,
            flexGrow: 1,
            overflow: "visible",
          }}
        >
          <Typography
            variant="body2"
            sx={{ mb: 2, color: "#666666", fontSize: "15px" }}
          >
            Please enter your password to decommission the Asset(s).
          </Typography>
          <form onSubmit={formikDecommission.handleSubmit}>
            {/* Only show password field if sso_enabled is false */}
            {!sso_enabled && (
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label={<Typography variant="body2" sx={{ fontWeight: 500 }}>Password</Typography>}
                name="password"
                value={formikDecommission.values.password}
                onChange={(e) => {
                  formikDecommission.handleChange(e);
                  // Validate on change for better UX
                  formikDecommission.setFieldTouched('password', true, false);
                }}
                onBlur={formikDecommission.handleBlur}
                error={
                  formikDecommission.touched.password &&
                  Boolean(formikDecommission.errors.password)
                }
                helperText={
                  formikDecommission.touched.password &&
                    typeof formikDecommission.errors.password === "string"
                    ? formikDecommission.errors.password
                    : !formikDecommission.touched.password && formikDecommission.values.password.length > 0
                      ? "Password must contain at least 8 characters with uppercase, lowercase, number and special character"
                      : undefined
                }
                sx={{
                  mb: 3,
                  "& label": {
                    color: "#1E2036",
                    fontWeight: 600,
                    fontSize: "14px",
                  },
                  "& label.Mui-focused": {
                    color: "#1E2036",
                    fontWeight: 600,
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#1E2036",
                      borderWidth: "1.5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#1E2036",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1E2036",
                    },
                  },
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <span
                          className="visibility-icon"
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? (
                            <Visibility
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          ) : (
                            <VisibilityOff
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          )}
                        </span>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
            <TextField
              fullWidth
              multiline
              rows={3}
              label={<Typography variant="body2" sx={{ fontWeight: 500 }}>Reason</Typography>}
              name="reason"
              value={formikDecommission.values.reason}
              onChange={(e) => {
                formikDecommission.handleChange(e);
                // Validate on change for better UX
                formikDecommission.setFieldTouched('reason', true, false);
              }}
              onBlur={formikDecommission.handleBlur}
              error={
                formikDecommission.touched.reason &&
                Boolean(formikDecommission.errors.reason)
              }
              helperText={
                formikDecommission.touched.reason &&
                  typeof formikDecommission.errors.reason === "string"
                  ? formikDecommission.errors.reason
                  : !formikDecommission.touched.reason && formikDecommission.values.reason.length > 0
                    ? `${formikDecommission.values.reason.length}/120 characters. Must be 8-120 characters long.`
                    : formikDecommission.touched.reason && !formikDecommission.errors.reason
                      ? `${formikDecommission.values.reason.length}/120 characters. Valid reason provided.`
                      : "Please provide a reason for decommissioning (8-120 characters)"
              }
              sx={{
                mb: 0,
                "& label": {
                  color: "#1E2036",
                  fontWeight: 600,
                },
                "& label.Mui-focused": {
                  color: "#1E2036",
                  fontWeight: 600,
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#1E2036",
                    borderWidth: "1.4px",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1E2036",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1E2036",
                  },
                },
                "& .MuiInputBase-inputMultiline": {
                  padding: 0,
                },
              }}
            />

            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                paddingBottom: "16px",
                paddingTop: "16px",
                margin: 0,
                flexShrink: 0,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="error"
                disabled={
                  formikDecommission.isSubmitting ||
                  !formikDecommission.isValid ||
                  Object.keys(formikDecommission.errors).length > 0 ||
                  !formikDecommission.values.reason.trim() ||
                  (!sso_enabled && !formikDecommission.values.password.trim()) ||
                  (sso_enabled && formikDecommission.values.reason.length < 8) ||
                  (!sso_enabled && (formikDecommission.values.password.length < 8 || formikDecommission.values.reason.length < 8))
                }
                endIcon={
                  loading ? (
                    <CircularProgress size={15} color="inherit" />
                  ) : null
                }
                sx={{
                  backgroundColor: "#FB4B50",
                  color: "#ffffff",
                  width: 150,
                  opacity: (
                    formikDecommission.isSubmitting ||
                    !formikDecommission.isValid ||
                    Object.keys(formikDecommission.errors).length > 0 ||
                    !formikDecommission.values.reason.trim() ||
                    (!sso_enabled && !formikDecommission.values.password.trim()) ||
                    (sso_enabled && formikDecommission.values.reason.length < 8) ||
                    (!sso_enabled && (formikDecommission.values.password.length < 8 || formikDecommission.values.reason.length < 8))
                  ) ? 0.5 : 1,
                  transition: "opacity 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#e04449",
                    color: "#ffffff",
                  },
                  "&:active": {
                    backgroundColor: "#FB4B50",
                    color: "#ffffff",
                  },
                  "&:focus": {
                    backgroundColor: "#FB4B50",
                    color: "#ffffff",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FB4B50",
                    color: "#ffffff",
                    opacity: 0.5,
                  },
                }}
              >
                Decommission
              </Button>

              <Button
                onClick={handleDecommissionDialogClose}
                variant="outlined"
                sx={{
                  width: 150,
                  color: "#696595",
                  borderColor: "#696595",
                  "&:hover": {
                    color: "#696595",
                    borderColor: "#696595",
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  Cancel
                </Typography>
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={isCommissionDialogOpen}
        onClose={handleCommissionDialogClose}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "8px",
            padding: "16px",
            boxSizing: "border-box",
            maxHeight: "90vh",
            overflowY: "auto",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            color: isDarkMode ? "#fff" : "#101828",
            p: 1,
          }}
        >
          Are you sure you want to commission Asset(s)?
        </DialogTitle>
        <DialogContent
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#667085",
            mt: "4px",
            p: 1,
            overflow: "visible",
          }}
        >
          {/* Only show scan date info when single asset is selected */}
          {selectedRows.length <= 1 && (
            <>
              <Typography variant="body2" sx={{ mb: 2, color: isDarkMode ? "#E5E7EB" : "#666666" }}>
                Last Scan Date:{commissionRowData?.last_scan_date}
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, color: isDarkMode ? "#E5E7EB" : "#666666" }}>
                No Of Days since last scan:{commissionRowData?.days_since_last_scan}
              </Typography>
            </>
          )}
          <Typography variant="body2" sx={{ mb: 2, color: isDarkMode ? "#E5E7EB" : "#666666" }}>
            Enter your password to commission the Asset(s)
          </Typography>
          <form onSubmit={formikCommission.handleSubmit}>
            {/* Only show password field if sso_enabled is false */}
            {!sso_enabled && (
              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formikCommission.values.password}
                onChange={formikCommission.handleChange}
                onBlur={formikCommission.handleBlur}
                error={
                  formikCommission.touched.password &&
                  Boolean(formikCommission.errors.password)
                }
                helperText={
                  formikCommission.touched.password &&
                    typeof formikCommission.errors.password === "string"
                    ? formikCommission.errors.password
                    : undefined
                }
                sx={{ mb: 2 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <span
                          className="visibility-icon"
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? (
                            <Visibility
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          ) : (
                            <VisibilityOff
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          )}
                        </span>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Reason"
              name="reason"
              value={formikCommission.values.reason}
              onChange={formikCommission.handleChange}
              onBlur={formikCommission.handleBlur}
              error={
                formikCommission.touched.reason &&
                Boolean(formikCommission.errors.reason)
              }
              helperText={
                formikCommission.touched.reason &&
                  typeof formikCommission.errors.reason === "string"
                  ? formikCommission.errors.reason
                  : undefined
              }
              sx={{ mb: 1 }}
            />
            {/* For cloud resources, automatically trigger live rescan with optional credential selection */}
            {(isCloudAsset(commissionRowData) || commissionRowData?.scan_source === "cloud" || commissionRowData?.type === "cloud" || environmentFilter === "cloud") && (
              <Box sx={{ mb: 1, mt: 0.5 }}>
                <FormControl fullWidth size="small" sx={{ mt: 0.5, mb: 0.5 }}>
                  <InputLabel id="cloud-rescan-credential-label" sx={{ fontSize: "13px" }}>
                    Select AWS Credential (Optional)
                  </InputLabel>
                  <Select
                    labelId="cloud-rescan-credential-label"
                    id="cloud-rescan-credential"
                    value={formikCommission.values.cred_id}
                    label="Select AWS Credential (Optional)"
                    onChange={(e) =>
                      formikCommission.setFieldValue("cred_id", e.target.value)
                    }
                    sx={{ fontSize: "13px" }}
                  >
                    <MenuItem value="">
                      <em>Auto (Use account's mapped credential)</em>
                    </MenuItem>
                    {cloudCredentials.map((cred: any) => (
                      <MenuItem key={cred.id} value={cred.id} sx={{ fontSize: "13px" }}>
                        {cred.name || cred.credential_name || cred.id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                paddingBottom: "24px",
                marginTop: "12px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={
                  !formikCommission.isValid ||
                  !formikCommission.dirty ||
                  formikCommission.isSubmitting
                }
                endIcon={
                  loading ? (
                    <CircularProgress size={15} color="inherit" />
                  ) : null
                }
                sx={{
                  opacity: formikCommission.isValid ? 1 : 0.5,
                  width: 130,
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                }}
              >
                Commission
              </Button>
              <Button
                onClick={handleCommissionDialogClose}
                variant="outlined"
                color="secondary"
                sx={{ width: 130 }}
              >
                Cancel
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={showRecommissionOptions}
        onClose={() => setShowRecommissionOptions(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          Select Recommission Option
        </DialogTitle>
        <DialogContent>
          {(() => {
            const isSimplifiedAsset = isSimplifiedRecommissionAsset(commissionRowData);

            return (
              <RadioGroup
                value={selectedRecommissionOption}
                onChange={(e) => setSelectedRecommissionOption(e.target.value)}
              >
                {isSimplifiedAsset ? (
                  // Endpoint and supported network vendors: show only SSH and Cancel.
                  <>
                    <FormControlLabel
                      value="ssh"
                      control={<Radio />}
                      label="Rescan by providing new SSH/API information"
                    />
                    <FormControlLabel
                      value="cancel"
                      control={<Radio />}
                      label="Cancel Recommission"
                    />
                  </>
                ) : (
                  // For non-Endpoint devices: Show original options based on scan_source
                  <>
                    <FormControlLabel
                      value="upload"
                      control={<Radio />}
                      label="Rescan by uploading a new config file of the same asset (Upload File)"
                    />
                    <FormControlLabel
                      value="previous"
                      control={<Radio />}
                      label="Rescan the asset with the previous config file"
                    />
                    <FormControlLabel
                      value="cancel"
                      control={<Radio />}
                      label="Cancel Recommission"
                    />
                  </>
                )}
              </RadioGroup>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setShowRecommissionOptions(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={!selectedRecommissionOption}
            onClick={() => handleRecommissionOptionSelect(selectedRecommissionOption)}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showSSHAPIOptions}
        onClose={() => setShowSSHAPIOptions(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          Select Recommission Option
        </DialogTitle>
        <DialogContent>
          <RadioGroup
            value={selectedSSHAPIOption}
            onChange={(e) => setSelectedSSHAAPIOption(e.target.value)}
          >
            {/* <FormControlLabel
              value="previous_config_ssh_api"
              control={<Radio />}
              label="Rescan by using the previous SSH or API details."
            /> */}
            <FormControlLabel
              value="new_config_ssh_api"
              control={<Radio />}
              label="Rescan by providing new SSH/API information."
            />
            <FormControlLabel
              value="new_config_upload"
              control={<Radio />}
              label="Rescan by uploading a new config file of the same asset."
            />
            <FormControlLabel
              value="rescan_old_config"
              control={<Radio />}
              label="Rescan using the old configuration data."
            />
            <FormControlLabel
              value="cancel"
              control={<Radio />}
              label="Cancel Recommission."
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setShowSSHAPIOptions(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={!selectedSSHAPIOption}
            onClick={() => handleRecommissionOptionSSHSelect(selectedSSHAPIOption)}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      <SingleFileUploadDialog
        open={showUploadDialog}
        onClose={() => {
          setShowUploadDialog(false);
          const isSimplifiedAsset = isSimplifiedRecommissionAsset(commissionRowData);

          if (isSimplifiedAsset) {
            // Keep the simplified recommission dialog available after closing.
            setShowRecommissionOptions(true);
            setSelectedRecommissionOption("cancel");
          } else if (commissionRowData.scan_source === "file") {
            // For non-Endpoint file-based: Show file options dialog
            setShowRecommissionOptions(true);
            setSelectedRecommissionOption("cancel");
          } else {
            // For non-Endpoint SSH/API: Show 4-option SSH dialog
            setShowSSHAPIOptions(true);
            setSelectedSSHAAPIOption("cancel");
          }
        }}
        onUpload={handleUpload}
      />
      <CustomAssetDrawer
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          const isSimplifiedAsset = isSimplifiedRecommissionAsset(commissionRowData);

          if (isSimplifiedAsset) {
            // Keep the simplified recommission dialog available after closing.
            setShowRecommissionOptions(true);
            setSelectedRecommissionOption("cancel");
          } else if (commissionRowData.scan_source === "file") {
            // For non-Endpoint file-based: Show file options dialog
            setShowRecommissionOptions(true);
            setSelectedRecommissionOption("cancel");
          } else {
            // For non-Endpoint SSH/API: Show 4-option SSH dialog
            setShowSSHAPIOptions(true);
            setSelectedSSHAAPIOption("cancel");
          }
        }}
        onUpload={handleSSHUpload}
        assetsCredData={assetsCredData}
        onPasswordTypeChange={handlePasswordTypeChange}
      />
      <Dialog
        open={isDeleteDialogOpen}
        onClose={handleDeleteDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "450px",
            height: sso_enabled ? "380px" : "415px",
            borderRadius: "4px",
            transform: "translate(-50%, -50%)",
            padding: "10px",
            boxSizing: "border-box",
            overflow: "hidden", // Prevent scrollbars by default
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px",
            p: "10px",

            color: isDarkMode ? "#fff" : "#101828",
          }}
        >
          Are you sure you want to delete asset(s)?
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "14px",
            color: "#667085",
            mt: "8px",
            overflow: "visible", // prevent scrollbar
            maxHeight: "none", // override default
          }}
        >
          <Typography
            variant="body2"
            sx={{ mb: 2, color: "#666666", fontSize: "14px" }}
          >
            {unique_devices
              ? "Please note that even if you delete this asset, it will be considered in the limit of unique assets."
              : "Please enter your password to delete the asset(s)."}
          </Typography>
          <form onSubmit={formikDelete.handleSubmit}>
            {/* Only show password field if sso_enabled is false */}
            {!sso_enabled && (
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label="Password"
                name="password"
                value={formikDelete.values.password}
                onChange={(e) => {
                  formikDelete.handleChange(e);
                  // Validate on change for better UX
                  formikDelete.setFieldTouched("password", true, false);
                }}
                onBlur={formikDelete.handleBlur}
                error={
                  formikDelete.touched.password &&
                  Boolean(formikDelete.errors.password)
                }
                helperText={
                  formikDelete.touched.password &&
                    typeof formikDelete.errors.password === "string"
                    ? formikDelete.errors.password
                    : !formikDelete.touched.password &&
                      formikDelete.values.password.length > 0
                      ? "Password must contain at least 8 characters with uppercase, lowercase, number and special character"
                      : undefined
                }
                sx={{ mb: 2 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <span
                          className="visibility-icon"
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? (
                            <Visibility
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          ) : (
                            <VisibilityOff
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          )}
                        </span>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Reason"
              name="reason"
              value={formikDelete.values.reason}
              onChange={(e) => {
                formikDelete.handleChange(e);
                // Validate on change for better UX
                formikDelete.setFieldTouched("reason", true, false);
              }}
              onBlur={formikDelete.handleBlur}
              error={
                formikDelete.touched.reason &&
                Boolean(formikDelete.errors.reason)
              }
              helperText={
                formikDelete.touched.reason &&
                  typeof formikDelete.errors.reason === "string"
                  ? formikDelete.errors.reason
                  : !formikDelete.touched.reason &&
                    formikDelete.values.reason.length > 0
                    ? `${formikDelete.values.reason.length}/120 characters. Must be 8-120 characters long.`
                    : formikDelete.touched.reason &&
                      !formikDelete.errors.reason
                      ? `${formikDelete.values.reason.length}/120 characters. Valid reason provided.`
                      : "Please provide a reason for deletion (8-120 characters)"
              }
              sx={{ mb: 1 }}
            />

            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                // paddingBottom: "24px",
                // marginTop: "12px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={
                  formikDelete.isSubmitting ||
                  !formikDelete.isValid ||
                  Object.keys(formikDelete.errors).length > 0 ||
                  !formikDelete.values.reason.trim() ||
                  (!sso_enabled && !formikDelete.values.password.trim()) ||
                  (sso_enabled && formikDelete.values.reason.length < 8) ||
                  (!sso_enabled &&
                    (formikDelete.values.password.length < 8 ||
                      formikDelete.values.reason.length < 8)) ||
                  loading ||
                  isButtonDisabled
                }
                endIcon={
                  loading ? <CircularProgress size={15} color="inherit" /> : null
                }
                sx={{
                  opacity:
                    formikDelete.isSubmitting ||
                      !formikDelete.isValid ||
                      Object.keys(formikDelete.errors).length > 0 ||
                      !formikDelete.values.reason.trim() ||
                      (!sso_enabled && !formikDelete.values.password.trim()) ||
                      (sso_enabled && formikDelete.values.reason.length < 8) ||
                      (!sso_enabled &&
                        (formikDelete.values.password.length < 8 ||
                          formikDelete.values.reason.length < 8))
                      ? 0.5
                      : 1,
                  width: 130,
                  backgroundColor: "#FB4B50",
                  color: "#fff",
                  transition: "opacity 0.2s ease-in-out, background-color 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#FB4B50", // keeps it the same red
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FB4B50",
                    color: "#fff",
                    opacity: 0.5,
                  },
                }}
              >
                Delete
              </Button>

              <Button
                onClick={handleDeleteDialogClose}
                variant="outlined"
                color="secondary"
                sx={{ width: 130 }}
              >
                Cancel
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <Drawer
        anchor={"right"}
        open={openSidenav}
        onClose={() => toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>
      <Dialog open={isFirstPopupOpen} onClose={handleCancel}
        sx={{
          "& .MuiPaper-root": {
            width: "370px",
            height: "270px",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: '16px', fontWeight: '700' }}>Scan Schedule</DialogTitle>
        <DialogContent sx={{ padding: '18px' }}>
          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <FormControlLabel
              value="0"
              control={<Radio sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }} />}
              label={
                <Typography
                  sx={{
                    color: selectedOption === "0" ? "#3A2ADA" : "inherit",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Manrope",
                  }}
                >
                  Remove from all the existing schedule
                </Typography>
              }
            />
            <FormControlLabel
              value="1"
              control={<Radio sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }} />}
              label={
                <Typography
                  sx={{
                    color: selectedOption === "1" ? "#3A2ADA" : "inherit",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Manrope",
                  }}
                >
                  Remove from all of my schedule
                </Typography>
              }
            />
            <FormControlLabel
              value="2"
              control={<Radio sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }} />}
              label={
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Manrope",
                    color: selectedOption === "2" ? "#3A2ADA" : "inherit",
                  }}
                >
                  Add without removing from other schedule
                </Typography>
              }
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "24px",
            // marginTop: "12px",
          }}
        >
          <Button
            onClick={handleCancel}
            variant="outlined"
            color="secondary"
            sx={{ width: 130 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleNext}
            variant="contained"
            color="primary"
            sx={{ width: 130 }}
            disabled={!selectedOption} // Disable Next button if no option is selected
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isSecondPopupOpen} onClose={handleSecondPopupClose}
        sx={{
          "& .MuiPaper-root": {
            width: "370px",
            height: "520px",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: '16px', fontWeight: '700', padding: '15px 15px 5px 15px' }}>Scan Schedule</DialogTitle>
        <DialogContent sx={{ padding: '15px' }}>
          <Typography variant="body2" sx={{ fontSize: '13px', fontWeight: 500, color: isDarkMode ? '#fff' : '#666666', }}>
            You are scheduling this asset which will remove from all the
            schedules. Select an option to schedule a scan to continue.
          </Typography>
          <RadioGroup
            value={selectedscheduleOption}
            onChange={(e) => {
              setScheduleSelectedOption(e.target.value);
              setSelectedItem(null)
              formikScheduleScan.resetForm();
            }}
            row
            sx={{ mb: 2 }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: '2px' }}>
              <FormControlLabel
                value="new_schedule"
                control={<Radio sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }} />}
                label={<Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Manrope",
                    color: selectedscheduleOption === "new_schedule" ? "#3A2ADA" : "inherit",
                  }}
                >
                  New Schedule
                </Typography>
                }
              />
              <FormControlLabel
                value="existing_scan"
                control={<Radio sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }} />}
                label={<Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Manrope",
                    color: selectedscheduleOption === "new_schedule" ? "inherit" : "#3A2ADA",
                  }}
                >
                  Add to an existing scan
                </Typography>
                }
              />
            </div>

          </RadioGroup>
          {selectedscheduleOption === "new_schedule" && (
            <form onSubmit={formikScheduleScan.handleSubmit}>
              <TextField
                fullWidth
                style={{ marginBottom: "16px" }}
                label="Scan Name"
                name="scanName"
                variant="outlined"
                value={formikScheduleScan.values.scanName}
                onChange={formikScheduleScan.handleChange}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.scanName &&
                  Boolean(formikScheduleScan.errors.scanName)
                }
                helperText={
                  formikScheduleScan.touched.scanName &&
                  formikScheduleScan.errors.scanName
                }
              />

              <TextField
                fullWidth
                style={{ marginBottom: "16px" }}
                select
                label="Frequency"
                name="frequency"
                variant="outlined"
                value={selectedFrequency}
                onChange={(e) => {
                  const selectedOption: any = scheduleOptionsFrequency.find(
                    (option: any) => option.name === e.target.value
                  );
                  formikScheduleScan.handleChange(e);
                  formikScheduleScan.setFieldValue(
                    "frequencyId",
                    selectedOption?.id || ""
                  );
                  formikScheduleScan.setFieldValue("day", "");
                  formikScheduleScan.setFieldValue("onDate", "");
                  formikScheduleScan.setTouched({
                    ...formikScheduleScan.touched,
                    onDate: false,
                  });
                }}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.frequency &&
                  Boolean(formikScheduleScan.errors.frequency)
                }
                helperText={
                  formikScheduleScan.touched.frequency &&
                  formikScheduleScan.errors.frequency
                }
              >
                {scheduleOptionsFrequency.map((option: any) => (
                  <MenuItem key={option.id} value={option.name}>
                    {typeof option.name === "string" ||
                      typeof option.name === "number"
                      ? option.name
                      : JSON.stringify(option.name)}
                  </MenuItem>
                ))}
              </TextField>

              {selectedFrequency !== "Daily" &&
                selectedFrequency !== "Hourly" &&
                selectedFrequency !== "Weekly" && (
                  <TextField
                    fullWidth
                    style={{ marginBottom: "16px" }}
                    label="On Date"
                    type="date"
                    name="onDate"
                    variant="outlined"
                    slotProps={{ inputLabel: { shrink: true } }}
                    value={formikScheduleScan.values.onDate}
                    onChange={formikScheduleScan.handleChange}
                    onBlur={formikScheduleScan.handleBlur}
                    error={
                      formikScheduleScan.touched.onDate &&
                      Boolean(formikScheduleScan.errors.onDate)
                    }
                    helperText={
                      formikScheduleScan.touched.onDate &&
                      formikScheduleScan.errors.onDate
                    }
                  />
                )}

              {selectedFrequency === "Weekly" && (
                <TextField
                  fullWidth
                  style={{ marginBottom: "16px" }}
                  select
                  label="Day"
                  name="day"
                  variant="outlined"
                  value={formikScheduleScan.values.day}
                  onChange={formikScheduleScan.handleChange}
                  onBlur={formikScheduleScan.handleBlur}
                  error={
                    formikScheduleScan.touched.day &&
                    Boolean(formikScheduleScan.errors.day)
                  }
                  helperText={
                    formikScheduleScan.touched.day &&
                    formikScheduleScan.errors.day
                  }
                >
                  {scheduleOptionsWeekly.map((option: any) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}

              <TextField
                fullWidth
                select
                label="At Time"
                name="atTime"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={formikScheduleScan.values.atTime}
                onChange={formikScheduleScan.handleChange}
                onBlur={formikScheduleScan.handleBlur}
                error={
                  formikScheduleScan.touched.atTime &&
                  Boolean(formikScheduleScan.errors.atTime)
                }
                helperText={
                  formikScheduleScan.touched.atTime &&
                  formikScheduleScan.errors.atTime
                }
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      className: "scroll",
                      style: {
                        maxHeight: 150,
                        overflowY: "auto",
                      },
                    },
                  },
                  native: false,
                  renderValue: (value) =>
                    typeof value === "string" ? value : "Enter Time",
                }}
              >
                {Array.from({ length: 1440 }, (_, i) => {
                  const hours = Math.floor(i / 60);
                  const minutes = i % 60;
                  const time = `${String(hours % 12 || 12).padStart(
                    2,
                    "0"
                  )}:${String(minutes).padStart(2, "0")} ${hours < 12 ? "AM" : "PM"
                    }`;
                  return (
                    <MenuItem key={time} value={time}>
                      {time}
                    </MenuItem>
                  );
                })}
              </TextField>
            </form>
          )}
          {selectedscheduleOption === "existing_scan" && (
            <>
              <TextField
                fullWidth
                placeholder="Search"
                variant="outlined"
                value={formikScheduleScan.values.search || ""}
                onChange={(e) => {
                  formikScheduleScan.setFieldValue("search", e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      onClick={() =>
                        formikScheduleScan.setFieldValue("search", "")
                      }
                      size="small"
                      sx={{ minWidth: "auto" }}
                    >
                      X
                    </Button>
                  ),
                }}
                sx={{ mb: 2 }}
              />
              <Box
                sx={{
                  maxHeight: 200,
                  overflowY: "auto",
                  overflowX: "hidden",
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  p: 1,
                }}
                className="scroll"
              >

                {scanSummaryData.filter((item: any) => {
                  if (!formikScheduleScan.values.search) return true;
                  const search = formikScheduleScan.values.search.toLowerCase();
                  return (
                    item.schedule_name?.toLowerCase().includes(search) ||
                    item.frequecy_name?.toLowerCase().includes(search)
                  );
                }).length === 0 ? (
                  <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                  >
                    No data found
                  </Typography>
                ) : (
                  scanSummaryData
                    .filter((item: any) => {
                      if (!formikScheduleScan.values.search) return true;
                      const search = formikScheduleScan.values.search.toLowerCase();
                      return (
                        item.schedule_name?.toLowerCase().includes(search) ||
                        item.frequecy_name?.toLowerCase().includes(search)
                      );
                    })
                    .map((item: any, index: number) => (
                      <Box
                        key={index}
                        onClick={() => {
                          setSelectedIndex(index);
                          setSelectedItem(item);
                        }}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                          p: 1,
                          borderRadius: 1,
                          backgroundColor: selectedIndex === index ? "#c8e6c9" : "#f9f9f9",
                          "&:hover": {
                            backgroundColor: selectedIndex === index ? "#aed581" : "#e0f7fa",
                          },
                        }}
                        title={`${item.schedule_name} - ${item.frequecy_name}`}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            flex: 1,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color:
                              formikScheduleScan.values.search &&
                                (item.schedule_name?.toLowerCase() || "").includes(
                                  formikScheduleScan.values.search.toLowerCase()
                                )
                                ? "blue"
                                : "inherit",
                          }}
                        >
                          {item.schedule_name}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            flex: 1,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: "right",
                            color:
                              formikScheduleScan.values.search &&
                                (item.frequecy_name?.toLowerCase() || "").includes(
                                  formikScheduleScan.values.search.toLowerCase()
                                )
                                ? "blue"
                                : "inherit",
                          }}
                        >
                          {item.frequecy_name}
                        </Typography>
                      </Box>
                    ))
                )}

              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {


              setIsSecondPopupOpen(false);
              setIsFirstPopupOpen(true);
              setSelectedOption("0");
              setScheduleSelectedOption("new_schedule");
              formikScheduleScan.resetForm();

            }}
            variant="outlined"
            color="primary"
          >
            Back
          </Button>
          <Button
            onClick={handleSecondPopupClose}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
          {selectedscheduleOption === "new_schedule" ? (
            <Button
              type="submit"
              onClick={() => {
                formikScheduleScan.handleSubmit();
                setIsSecondPopupOpen(false);
              }}
              variant="contained"
              color="primary"
              disabled={
                !formikScheduleScan.isValid ||
                formikScheduleScan.isSubmitting ||
                !formikScheduleScan.values.scanName ||
                !formikScheduleScan.values.frequency ||
                !formikScheduleScan.values.atTime ||
                (
                  formikScheduleScan.values.frequency === "Weekly" &&
                  !formikScheduleScan.values.day
                ) ||
                (
                  !["Daily", "Hourly", "Weekly"].includes(formikScheduleScan.values.frequency) &&
                  !formikScheduleScan.values.onDate
                )
              }
            >
              Schedule
            </Button>
          ) : (
            <Button
              type="submit"
              onClick={() => {
                if (selectedscheduleOption === "existing_scan" && !selectedItem) {
                  toast.success("Please select an existing scan to continue.");
                  return;
                } else if (selectedscheduleOption === "existing_scan" && selectedItem) {
                  //formikScheduleScan.setFieldValue("scanId", selectedItem.id);
                  const convertToUTC = (time: string, date?: string) => {
                    if (time) {
                      let utcDate;
                      if (date) {
                        const [day, month, year] = date.split("-").map(Number);
                        const [hours, minutes] = time
                          .split(/[: ]/)
                          .map((value, index) =>
                            index === 0 && time.includes("PM") && value !== "12"
                              ? +value + 12
                              : value === "12" && time.includes("AM")
                                ? 0
                                : +value
                          );
                        const localDate = new Date(year, month - 1, day, hours, minutes);
                        utcDate = new Date(
                          localDate.getUTCFullYear(),
                          localDate.getUTCMonth(),
                          localDate.getUTCDate(),
                          localDate.getUTCHours(),
                          localDate.getUTCMinutes(),
                          localDate.getUTCSeconds()
                        );
                      } else {
                        const now = new Date();
                        const [hours, minutes] = time
                          .split(/[: ]/)
                          .map((value, index) =>
                            index === 0 && time.includes("PM") && value !== "12"
                              ? +value + 12
                              : value === "12" && time.includes("AM")
                                ? 0
                                : +value
                          );
                        const localDate = new Date(
                          now.getFullYear(),
                          now.getMonth(),
                          now.getDate(),
                          hours,
                          minutes
                        );
                        utcDate = new Date(
                          localDate.getUTCFullYear(),
                          localDate.getUTCMonth(),
                          localDate.getUTCDate(),
                          localDate.getUTCHours(),
                          localDate.getUTCMinutes(),
                          localDate.getUTCSeconds()
                        );
                      }
                      const utcHours = String(utcDate.getHours()).padStart(2, "0");
                      const utcMinutes = String(utcDate.getMinutes()).padStart(2, "0");
                      const formattedTime = `${utcHours}:${utcMinutes}`;

                      return formattedTime;
                    }
                  };
                  selectedItem.time = convertToUTC(
                    selectedItem.time,

                  )
                  selectedItem.remove_option = selectedOption;
                  selectedItem.device_ids = [selectedItem.device_ids, ...deviceIds],
                    schedule(selectedItem);

                }
              }}
              variant="contained"
              color="primary"
              disabled={
                !selectedItem
              }
            >
              Schedule
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={isCancelSchedulePopupOpen}
        onClose={handleCancelScheduleClose}
      >
        <DialogTitle>Cancel Schedule</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Select an option to cancel the schedule scan.
          </Typography>
          <RadioGroup
            value={removeAllSchedules ? "remove_all" : "remove_my"}
            onChange={(e) =>
              setRemoveAllSchedules(e.target.value === "remove_all")
            }
          >
            <FormControlLabel
              value="remove_my"
              control={<Radio />}
              label="Remove from my schedule"
              sx={{
                "& .MuiTypography-root": {
                  color: !removeAllSchedules ? "blue" : "inherit",
                },
              }}
            />
            <FormControlLabel
              value="remove_all"
              control={<Radio />}
              label="Remove from all schedule"
              sx={{
                "& .MuiTypography-root": {
                  color: removeAllSchedules ? "blue" : "inherit",
                },
              }}
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "24px",
            marginTop: "12px",
          }}
        >
          <Button
            onClick={handleCancelScheduleClose}
            variant="outlined"
            color="secondary"
            sx={{ width: 120 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveSchedule}
            variant="contained"
            color="primary"
            sx={{ width: 120 }}
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
      <RescanWithCredentialPopup
        open={isRescanPopupOpen}
        onClose={handleRescanPopupClose}
        assetsCredData={assetsCredData}
        credData={credTypes}
        deviceId={deviceIds}
        rescanCallback={rescanWithCredential}
      />
      <MapCredentialPopup
        open={isMapCredentialPopupOpen}
        onClose={handleMapPopuplose}
        assetsCredData={assetsCredData}
        credData={credTypes}
        deviceId={deviceIds}
        mapCallback={mapCallback}
      />
      {mapTemplateDevices.length > 1 ? (
        <MapMultiAssetTemplateDialog
          open={isMapTemplateDialogOpen}
          onClose={handleMapTemplateDialogClose}
          devices={mapTemplateDevices}
          isDarkMode={isDarkMode}
        />
      ) : (
        <MapAssetTemplateDialog
          open={isMapTemplateDialogOpen}
          onClose={handleMapTemplateDialogClose}
          devices={mapTemplateDevices}
          isDarkMode={isDarkMode}
        />
      )}
      <DiscoveryRescanPopup
        open={isDiscoveryRescanOpen}
        onClose={() => setIsDiscoveryRescanOpen(false)}
        rowData={discoveryRescanRowData}
        initialAgents={cloudAgents}
        useNewScanCredentialApi
      />
      {/* <AssetDetailsDrawer
        open={assetDrawerOpen}
        onClose={() => {
          setAssetDrawerOpen(false);
        }}
        assetData={selectedAssetSideNav}
        isCloud={false}
        isMenu={MenuKebabDrawer}
        onReport={handleAssetComplianceReport}
        isCve={true}
      /> */}
      <AssetDetailsDrawer
        open={assetDrawerOpen}
        onClose={() => setAssetDrawerOpen(false)}
        assetData={selectedAssetSideNav}
        isCloud={isCloudAsset(selectedAssetSideNav)}
        isMenu={showMenu ? MenuKebabDrawer : null}  // 👈 condition applied here
        onReport={handleAssetComplianceReport}
        isCve={true}
        isV2={true}
      />
      <Dialog
        open={isAssetCriticalityDialogOpen}
        onClose={handleAssetCriticalityDialogClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          Set Asset Criticality
        </DialogTitle>
        <DialogContent>
          <Typography align="center" sx={{ mb: 2, color: "gray" }}>
            Select an option to set the criticality for the asset_name.
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Select Criticality</InputLabel>
            <Select
              value={selectedCriticalId}
              label="Select Criticality"
              onChange={(e) => setSelectAssetsCriticaledId(e.target.value)}
            >
              {assetCriticalityOptions.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="outlined"
            onClick={handleAssetCriticalityDialogClose}
            sx={{ width: 150 }}
          >
            Cancel
          </Button>
          <Button
            disabled={selectedCriticalId === ""}
            variant="contained"
            onClick={handleAssetCriticality}
            sx={{ width: 150 }}
          >
            Set
          </Button>
        </DialogActions>
      </Dialog>
      <Drawer
        anchor="right"
        open={reportDrawerOpen}
        onClose={() => {
          setAssetDrawerOpen(true);
          setReportDrawerOpen(false);
        }}
        PaperProps={{ sx: { width: 400, borderRadius: 2 } }}
      >
        <AssetComplianceReportDrawer
          onClose={() => {
            setAssetDrawerOpen(true);
            setReportDrawerOpen(false);
          }}
          assetData={selectedAssetSideNav}
          isCloud={isCloudAsset(selectedAssetSideNav)}
        />
      </Drawer>
      <Dialog
        onClose={() => setIsCalenderIconClicked(false)}
        open={isCalenderIconClicked}
        sx={{
          "& .MuiDialog-paper": {
            width: "800px",
            height: "400px",
            maxWidth: "90vw",
            maxHeight: "90vh",
            margin: "auto",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <ScheduledTable
          scheduledTableInfo={scheduledTableInfo}
          tableHeading={isTableParams}
        />
      </Dialog>
    </Card>
  </Box>
  );
};

export default AssetsDetailsV2;